import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Drawer,
  FormControl,
  Grid2,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Dropdown from "../../reusable_components/components/Dropdown";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import MUIButton from "../../reusable_components/components/MUIButton";
import { useContext, useEffect, useMemo, useState } from "react";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import {
  useBindingEditJobPostingMutation,
  useCoordinatorDialogDropDownQuery,
  useGenerateJobDescriptionsMutation,
  useGetClientDropdownForJobQuery,
  useMatchProfileListMutation,
} from "../../redux/jobpostings/jobpostings.api";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import DescriptionIcon from "@mui/icons-material/Description";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DoneIcon from "@mui/icons-material/Done";
import UploadCloudIcon from "../../assets/Icons/UploadCloudIcon";
import CalendarIcon from "../../assets/Icons/CalendarIcon";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import DocumentLoader from "../../reusable_components/components/DocumentLoader";
import EmailIcon from "@mui/icons-material/Email";
import Loader from "../../reusable_components/components/Loader";
import { useGetEmailDropdownQuery } from "../../redux/candidateprofiles/candidateprofiles.api";
import ClearIcon from "@mui/icons-material/Clear";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import approve from "../../assets/approve.png";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import * as ReactDOMServer from "react-dom/server";
import ReactQuill from "react-quill";
import ORLogo from "../../assets/or1.svg";
import { GeminiLoader } from "../../reusable_components/components/GeminiLoader";
import geminiLogo from "../../assets/gemini.png";
import {
  useGetPositionLevelDropDownQuery,
  useGetWorkCategoryDropDownQuery,
} from "../../redux/Signup/signup.api";
const AddJobPostings = () => {
  const { Profile } = useSelector((state) => state.common);
  const userRole = Profile?.profile?.role;
  const useremail = Profile?.profile?.emailId;

  const params = useParams();
  const editScreen = +params?.id;

  const location = useLocation();
  const { isReferrals, referrals } = location?.state || "";
  const { isReferJob } = location?.state || "";

  const [status, setStatus] = useState(false);
  const [isCost, setIsCost] = useState(false);
  const [isValue, setIsValue] = useState();
  const [isCanCost, setIsCanCost] = useState(false);
  const [canValue, setCanValue] = useState();
  const [isFeedback, setIsFeedback] = useState(false);
  const [isStatus, setIsStatus] = useState("");
  const [finalSourcedBy, setFinalSourcedBy] = useState();
  const [showLoder, setShowLoder] = useState(false);
  const [openPostionType, setOpenPostionType] = useState(false);
  const [openPriority, setOpenPriority] = useState(false);
  const [openWorkmode, setOpenWorkmode] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);

  const [jobDescLength, setJobDescLength] = useState(0);
  const maxLength = 1500;

  const [open, setOpen] = useState(false);
  const [generateAIText, setGenerateAIText] = useState("");
  const [copy, setCopy] = useState(false);
  const [generateJobDescriptions] = useGenerateJobDescriptionsMutation();
  const [backendAI, setBackendAi] = useState("");
  const [generating, setGenerating] = useState(false);
  const { data: getWorkCategoryDropDown } = useGetWorkCategoryDropDownQuery();
  const { data: getPositionLevelDropDown } = useGetPositionLevelDropDownQuery();
  const [selectedKeywordIds, setSelectedKeywordIds] = useState();
  const [selectedlevelIds, setSelectedlevelIds] = useState();
  const units = [
    {
      id: 1,
      label: "INR",
    },
    {
      id: 2,
      label: "USD",
    },
    {
      id: 3,
      label: "CAD",
    },
    {
      id: 4,
      label: "AED",
    },
  ];

  const periodOfTime = [
    {
      id: "Y",
      label: "Per Year",
    },
    {
      id: "M",
      label: "Per Month",
    },
    {
      id: "D",
      label: "Per Day",
    },
    {
      id: "H",
      label: "Per Hour",
    },
  ];

  const toolBarOptions = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, false] }, { font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }, { background: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image"],
      ["clean"],
      // ['undo', 'redo'],
    ],
  };

  const validationSchema = Yup.object().shape({
    clientId: Yup.string().required("Client Name is required"),
    positionType: Yup.string().required("Position type is required"),
    positionDesc: Yup.string()
      .required("Position title is required")
      .min(3, "Position title must be at least 3 characters "),

    positionCount: Yup.number()
      .typeError("Number of position is required")
      .required("Number of Positions is required")
      .min(1, "Number of Positions must be a positive number")
      .moreThan(0, "Number of position should be greater than zero"),
    jobLocation: Yup.string()
      .required("Job location is required")
      .matches(
        /^[A-Za-z]+(?: [A-Za-z]+)*$/,
        "Job Location should contain only letters"
      )
      .min(3, "Location must be at least 3 characters"),

    minExperience: Yup.number()
      .typeError("Minimum Experience is required")
      .required("Minimum Experience is required")
      .moreThan(-1, "Minimum Experience must be a positive number"),

    openDate: !editScreen
      ? Yup.date().nullable()
      : Yup.date().nullable().required("Open Date is required"),
    closeDate: !editScreen ? Yup.date().nullable() : Yup.date().nullable(),

    priority: Yup.string().required("Priority is required"),
    workLocation: Yup.string().required("Work mode is required"),
    positionStatus: status
      ? Yup.string().required("Status is required")
      : Yup.string(),
    coordinatorId:
      userRole === "recruiter" || isReferrals
        ? Yup.array()
        : Yup.array().min(1, "Co-ordinator is required"),
    feedBack: isFeedback
      ? Yup.string().test(
        "feedback-required",
        "Reason is required",
        function (value) {
          const status = this.parent.positionStatus;
          return status === "Active" || (value && value.trim().length > 0);
        }
      )
      : Yup.string(),
    rewardType:
      finalSourcedBy === "BA" &&
        userRole === "admin" &&
        isStatus === "Active"
        ? Yup.string().required("Job reward type is required")
        : Yup.string(),
    rewardsRs:
      finalSourcedBy === "BA" &&
        (isCost ||
          (isCost &&
            userRole === "admin" &&
            isStatus === "Active"))
        ? Yup.string()
          .required("Job reward amount is required")
          .matches(
            /^[1-9][0-9]*$/,
            "Job reward amount should be greater than 0."
          )
        : Yup.string().nullable().notRequired(),
    rewardsPercent:
      finalSourcedBy === "BA" &&
        ((isCost === false && isValue) ||
          (isCost === false &&
            userRole === "admin" &&
            isStatus === "Active"))
        ? Yup.number()
          .typeError("Job reward percentage is required")
          .required("Job reward percentage is required")
          .min(1, "Value must be greater than 0")
          .max(100, "Percentage cannot exceed 100")
        : Yup.mixed()
          .transform((value, originalValue) => {
            return originalValue === "" ? undefined : Number(originalValue);
          })
          .test(
            "is-valid-percentage",
            "Value must be between 1 and 100",
            (value) => {
              // If empty, skip validation
              if (value === undefined || value === null) return true;
              // Only validate when user enters something
              return !isNaN(value) && value >= 1 && value <= 100;
            }
          ),
    budgetCost: Yup.number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value
      )
      .nullable()
      .notRequired(),
    // .moreThan(0, 'Budgeted Cost must be greater than zero'),
    units: Yup.string().notRequired(),
    periodOfTime: Yup.string().notRequired(),
    primarySkill: Yup.string()
      .required("Primary skill is required")
      .max(300, "Maximum 300 characters allowed"),
    secondarySkill: Yup.string()
      .nullable()
      .notRequired()
      .max(300, "Maximum 300 characters allowed"),
    qualification: Yup.string()
      .nullable()
      .notRequired()
      .max(300, "Maximum 300 characters allowed"),
    candidateRewardType:
      userRole === "admin" && isStatus === "Active"
        ? Yup.string().required("Candidate reward type  is required")
        : Yup.string(),
    candidateRewardAmount:
      isCanCost || (isCanCost && userRole === "admin" && isStatus === "Active")
        ? Yup.string()
          .required("Candidate reward amount is required")
          .matches(
            /^[1-9][0-9]*$/,
            "Candidate reward amount should be greater than 0."
          )
        : Yup.string()
          .nullable()
          .notRequired()
          .test(
            "is-non-negative",
            "Reward amount cannot be negative",
            (value) => {
              if (!value) return true;
              const num = parseFloat(value);
              return !isNaN(num) && num >= 0;
            }
          ),
    candidateRewardPercentage:
      (isCanCost === false && canValue) ||
        (isCanCost === false && userRole === "admin" && isStatus === "Active")
        ? Yup.number()
          .typeError("Candidate reward percentage is required")
          .required("Candidate reward percentage is required")
          .min(1, "Value must be greater than 0")
          .max(100, "Percentage cannot exceed 100")
        : Yup.mixed()
          .transform((value, originalValue) => {
            return originalValue === "" ? undefined : Number(originalValue);
          })
          .test(
            "is-valid-percentage",
            "Value must be between 1 and 100",
            (value) => {
              // If empty, skip validation
              if (value === undefined || value === null) return true;
              // Only validate when user enters something
              return !isNaN(value) && value >= 1 && value <= 100;
            }
          ),


    jobDescription: Yup.string()
      .required("Job Description is required")
      .test(
        "max-plain-text",
        "Maximum 1500 characters allowed",
        function (value) {
          if (!value) return true; // let .required() handle empty
          const textOnly = value.replace(/<[^>]*>/g, "");
          const cleanText = textOnly.replace(/\s+/g, "");
          return cleanText.length <= 1500;
        }
      )
      .test(
        "not-empty",
        "Job Description is required",
        function (value) {
          if (!value) return false;
          const textOnly = value.replace(/<[^>]*>/g, "");
          return textOnly.trim().length > 0;
        }
      ),

    submittedBy: Yup.string().required("Sourced by is required"),
    category: Yup.number().required("Category is required"),
    level: Yup.number().required("Position Level is required"),
  });

  const [jobSubmittedById, setJobSubmittedById] = useState();


  const resolver = yupResolver(validationSchema);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    mode: "onChange",
    resolver,
    defaultValues: {
      clientId: "",
      positionType: "",
      positionDesc: "",
      positionCount: "",
      jobLocation: "",
      minExperience: "",
      openDate: null,
      jobDescription: "",
      closeDate: null,
      priority: "",
      workLocation: "",
      positionStatus: "",
      coordinatorId: [],
      feedBack: "",
      rewardType: "",
      rewardsRs: "",
      rewardsPercent: "",
      budgetCost: "",
      units: units[0]?.label,
      periodOfTime: periodOfTime[0]?.id,
      primarySkill: "",
      secondarySkill: "",
      qualification: "",
      candidateRewardType: 2,
      candidateRewardAmount: "",
      candidateRewardPercentage: 35,
      submittedBy: useremail,
      category: null,
      level: null,
    },
  });

  const positionType = watch("positionType");
  const statusType = watch("positionStatus");
  useEffect(() => {
    setIsStatus(statusType);
  }, [statusType]);

  const navigate = useNavigate();

  const theme = useTheme();
  const isSmallcreen = useMediaQuery(theme.breakpoints.down("md"));
  const { Snackbar } = useContext(SnackbarContext);

  const [dialogCoOrdinatorDropdown, setDialogCoordinatorDropdown] = useState(
    []
  );
  const [selectedCoordinatorsId, setSelectedCoordinatorsId] = useState([]);
  const [selectedCoordinatorsName, setSelectedCoordinatorsName] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [isFileChanged, setIsFileChanged] = useState(false);
  const [files, setFiles] = useState([]);
  const [filePath, setFilePath] = useState(null);
  const [fileExtension, setFileExtension] = useState("");
  const [positionId, setPositionId] = useState("");
  const [clientName, setClientName] = useState("");
  const [positionTitle, setPositionTitle] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [openSelect, setOpenSelect] = useState(false);

  const { data: coOrdinatorDialogDropdown } =
    useCoordinatorDialogDropDownQuery();
  const { data: getClientDropdown, refetch } =
    useGetClientDropdownForJobQuery();
  const [JobPostingDetailsByPositionId, { data: bindingEditJobPosting }] =
    useBindingEditJobPostingMutation();
  const { data: getDropdownDatas } = useGetEmailDropdownQuery();
  // Profile submission

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    // This below code is to call the binding api for the job edit screen
    if (editScreen) {
      const payload = {
        positionId: editScreen,
      };

      JobPostingDetailsByPositionId(payload);
    }
  }, [editScreen]);

  const [jobCreatedById, setJobCreatedById] = useState();

  useEffect(() => {
    if (bindingEditJobPosting) {
      const defaultValues = {
        clientId: bindingEditJobPosting?.response?.data[0]?.clientId,
        clientName: bindingEditJobPosting?.response?.data[0]?.clientName,
        closeDate: dayjs(bindingEditJobPosting?.response?.data[0]?.closedDate),
        filepath: bindingEditJobPosting?.response?.data[0]?.filepath,
        jobDescription:
          bindingEditJobPosting?.response?.data[0]?.jobDescription,
        jobLocation: bindingEditJobPosting?.response?.data[0]?.jobLocation,
        minExperience:
          bindingEditJobPosting?.response?.data[0]?.minimumExperience,
        positionCount: bindingEditJobPosting?.response?.data[0]?.noOfPosition,
        openDate: dayjs(bindingEditJobPosting?.response?.data[0]?.openDate),
        positionId: bindingEditJobPosting?.response?.data[0]?.positionId,
        positionDesc: bindingEditJobPosting?.response?.data[0]?.positionTitle,
        positionType: bindingEditJobPosting?.response?.data[0]?.positionType,
        priority: bindingEditJobPosting?.response?.data[0]?.priority,
        workLocation: bindingEditJobPosting?.response?.data[0]?.jobTypeCode,
        remarks: bindingEditJobPosting?.response?.data[0]?.remarks,
        positionStatus: bindingEditJobPosting?.response?.data[0]?.status,
        coordinatorId:
          bindingEditJobPosting?.response?.data[0]?.coordinatorList,
        submittedBy: bindingEditJobPosting?.response?.data[0]?.submittedBy,
        budgetCost:
          bindingEditJobPosting?.response?.data[0]?.budgetedCost ?? undefined,
        units:
          bindingEditJobPosting?.response?.data[0]?.budgetCurrency ?? undefined,
        periodOfTime:
          bindingEditJobPosting?.response?.data[0]?.budgetUnit ?? undefined,
        feedBack:
          bindingEditJobPosting?.response?.data[0]?.feedBack ?? undefined,
        rewardsRs:
          bindingEditJobPosting?.response?.data[0]?.rewardAmount === null
            ? ""
            : bindingEditJobPosting?.response?.data[0]?.rewardAmount,
        rewardType:
          bindingEditJobPosting?.response?.data[0]?.rewardType === null ||
            bindingEditJobPosting?.response?.data[0]?.rewardType === ""
            ? ""
            : bindingEditJobPosting?.response?.data[0]?.rewardType === "FC"
              ? 1
              : 2,

        rewardsPercent:
          bindingEditJobPosting?.response?.data[0]?.rewardPtc === null
            ? ""
            : bindingEditJobPosting?.response?.data[0]?.rewardPtc,
        secondarySkill:
          bindingEditJobPosting?.response?.data[0]?.secondarySkills,
        primarySkill: bindingEditJobPosting?.response?.data[0]?.primarySkills,
        qualification: bindingEditJobPosting?.response?.data[0]?.qualification,
        candidateRewardType:
          bindingEditJobPosting?.response?.data[0]?.candidateRewardType ===
            null ||
            bindingEditJobPosting?.response?.data[0]?.candidateRewardType === ""
            ? ""
            : bindingEditJobPosting?.response?.data[0]?.candidateRewardType ===
              "FC"
              ? 1
              : 2,

        candidateRewardPercentage:
          bindingEditJobPosting?.response?.data[0]
            ?.candidateRewardPercentage === null
            ? ""
            : bindingEditJobPosting?.response?.data[0]
              ?.candidateRewardPercentage,
        candidateRewardAmount:
          bindingEditJobPosting?.response?.data[0]?.candidateRewardAmount ===
            null
            ? ""
            : bindingEditJobPosting?.response?.data[0]?.candidateRewardAmount,
        category: bindingEditJobPosting?.response?.data[0]?.workCategoryId,
        level: bindingEditJobPosting?.response?.data[0]?.jobPositionLevelId,
      };

      const coordinators = defaultValues?.coordinatorId;
      const filePath = defaultValues?.filepath;
      const extension = filePath
        ?.substring(filePath?.lastIndexOf(".") + 1)
        .toLowerCase();
      const coordinatorsName = coordinators?.filter((id) => id?.hasSelected);
      const coordinatorsId = coordinatorsName?.map((id) => id?.coordinatorId);

      // setJobDesc(defaultValues?.jobDescription)

      setJobSubmittedById(
        bindingEditJobPosting?.response?.data[0]?.jobSubmittedById
      );
      setJobCreatedById(
        bindingEditJobPosting?.response?.data[0]?.jobCreatedById
      );

      setRemarks(defaultValues?.remarks);
      setFilePath(filePath);
      setFileExtension(extension);
      setSelectedCoordinatorsName(coordinatorsName);
      setSelectedCoordinatorsId(coordinatorsId);
      setPositionId(defaultValues?.positionId);
      setClientName(defaultValues?.clientName);
      setPositionTitle(defaultValues?.positionDesc);

      reset({
        ...defaultValues,
      });
      const textOnly = defaultValues?.jobDescription.replace(/<[^>]*>/g, "");
      const cleanText = textOnly.replace(/\s+/g, "");
      setJobDescLength(cleanText.length);
    }
  }, [bindingEditJobPosting]);

  useEffect(() => {
    setValue("submittedBy", useremail);
  }, []);

  useEffect(() => {
    if (coOrdinatorDialogDropdown) {
      setDialogCoordinatorDropdown(
        coOrdinatorDialogDropdown?.response?.coordinatorList
      );
    }
  }, [coOrdinatorDialogDropdown]);

  const handleCoordinatorChange = (e) => {
    const value = e.target.value;
    setSelectedCoordinatorsId(value);

    const coordinatorsName =
      coOrdinatorDialogDropdown?.response?.coordinatorList?.filter((id) =>
        selectedCoordinatorsId?.includes?.(id?.coordinatorId)
      );
    setSelectedCoordinatorsName(coordinatorsName);
  };

  const handleRemarksChange = (e) => {
    const value = e.target.value;
    setRemarks(value);
  };

  // const handleJobDescChange = (e) => {
  //     const value = e.target.value
  //     setJobDesc(value)
  // }

  const type = watch("rewardType");

  useEffect(() => {
    if (type === 1) {
      setIsCost(true);
    } else if (type === 2) {
      setIsValue(type);
      setIsCost(false);
    } else {
      setIsCost(false);
    }
  }, [watch, type]);

  const candidateType = watch("candidateRewardType");
  const candidateRewardAmount = watch("candidateRewardAmount");
  const candidateRewardPercentage = watch("candidateRewardPercentage");

  useEffect(() => {
    if (candidateType === 1) {
      setIsCanCost(true);
      setValue("candidateRewardPercentage", "");
    } else if (candidateType === 2) {
      setCanValue(candidateType);
      setIsCanCost(false);
      setValue("candidateRewardAmount", "");
    } else {
      setIsCanCost(false);
      setValue("candidateRewardAmount", "");
    }
  }, [candidateType, candidateRewardAmount, candidateRewardPercentage]);

  const handleFileChange = async (e) => {
    const file = Array.from(e.target.files);
    setFiles([...files, ...file]);
    setIsFileChanged(true);

    if (file.length > 0) {
      // Prepare formData
      const formData = new FormData();
      file.forEach((file) => {
        formData.append("file", file); // Append each file to formData
      });

      try {
        // Call the API
        setShowLoder(true);
        const response = await fetch(
          `${window.REACT_APP_BASE_URL}jobDescriptionParsing/upload`,
          {
            method: "POST",
            body: formData,
            // Content-Type is automatically set when using FormData
          }
        );
        setShowLoder(false);
        if (response?.ok) {
          const result = await response.json();
          // editScreen file Parsing
          if (editScreen) {
            const defaultValues = {
              clientName: result?.client_name,
              closeDate: dayjs(result?.closedDate),
              filepath: result?.filepath,
              jobDescription: result?.job_description,
              jobLocation: result?.job_location,
              minExperience: result?.minimum_experience,
              positionCount: result?.number_of_postions,
              openDate: dayjs(result?.openDate),
              positionDesc: result?.position_name,
              positionType: result?.position_type,
              priority: result?.priority,
              workLocation: result?.workLocation,
              remarks: result?.remarks,
              positionStatus: result?.status,
              coordinatorId: result?.coordinatorList,
              budgetUnit: result?.periodOfTime,
              budgetCurrency: result?.units,
              primarySkill: Array.isArray(result?.primary_skills)
                ? result.primary_skills.join(", ")
                : result?.primary_skills || "",
              secondarySkill: Array.isArray(result?.secondary_skills)
                ? result.secondary_skills.join(", ")
                : result?.secondary_skills || "",
              qualification: result?.qualification,
            };

            const coordinators = defaultValues?.coordinatorId;
            const filePath = defaultValues?.filepath;
            const extension = filePath
              ?.substring(filePath?.lastIndexOf(".") + 1)
              .toLowerCase();
            const coordinatorsName = coordinators?.filter(
              (id) => id?.hasSelected
            );
            const coordinatorsId = coordinatorsName?.map(
              (id) => id?.coordinatorId
            );

            // setJobDesc(defaultValues?.jobDescription)
            setRemarks(defaultValues?.remarks);
            setFilePath(filePath);
            setFileExtension(extension);
            setSelectedCoordinatorsName(coordinatorsName);
            setSelectedCoordinatorsId(coordinatorsId);
            setClientName(defaultValues?.clientName);
            setPositionTitle(defaultValues?.positionDesc);
            const textOnly = defaultValues?.jobDescription.replace(/<[^>]*>/g, "");
            const cleanText = textOnly.replace(/\s+/g, "");
            setJobDescLength(cleanText.length);
            reset({
              ...defaultValues,
            });

            setValue("clientId", bindingEditJobPosting?.response?.data[0]?.clientId || "");
            setValue("rewardType", bindingEditJobPosting?.response?.data[0]?.rewardType === null ||
              bindingEditJobPosting?.response?.data[0]?.rewardType === ""
              ? ""
              : bindingEditJobPosting?.response?.data[0]?.rewardType === "FC"
                ? 1
                : 2)

            setValue("rewardsPercent", bindingEditJobPosting?.response?.data[0]?.rewardPtc === null
              ? ""
              : bindingEditJobPosting?.response?.data[0]?.rewardPtc)
            setValue("rewardAmount", bindingEditJobPosting?.response?.data[0]?.rewardAmount === null
              ? ""
              : bindingEditJobPosting?.response?.data[0]?.rewardAmount);
            setValue("candidateRewardType", bindingEditJobPosting?.response?.data[0]?.candidateRewardType ===
              null ||
              bindingEditJobPosting?.response?.data[0]?.candidateRewardType === ""
              ? ""
              : bindingEditJobPosting?.response?.data[0]?.candidateRewardType ===
                "FC"
                ? 1
                : 2)
            setValue("candidateRewardPercentage", bindingEditJobPosting?.response?.data[0]
              ?.candidateRewardPercentage === null
              ? ""
              : bindingEditJobPosting?.response?.data[0]
                ?.candidateRewardPercentage);
            setValue("candidateRewardAmount", bindingEditJobPosting?.response?.data[0]?.candidateRewardAmount ===
              null
              ? ""
              : bindingEditJobPosting?.response?.data[0]?.candidateRewardAmount)

          } else {
            const defaultValues = {
              closeDate: dayjs(result?.closedDate),
              filepath: result?.filepath,
              jobDescription: result?.job_description,
              jobLocation: result?.job_location,
              minExperience: result?.minimum_experience,
              positionCount: result?.number_of_postions,
              openDate: dayjs(result?.openDate),
              positionDesc: result?.position_name,
              positionType: result?.position_type,
              priority: result?.priority,
              workLocation: result?.workLocation,
              remarks: result?.remarks,
              positionStatus: result?.status,
              coordinatorId: result?.coordinatorList,
              budgetUnit: result?.periodOfTime,
              budgetCurrency: result?.units,
              primarySkill: Array.isArray(result?.primary_skills)
                ? result.primary_skills.join(", ")
                : result?.primary_skills || "",
              secondarySkill: Array.isArray(result?.secondary_skills)
                ? result.secondary_skills.join(", ")
                : result?.secondary_skills || "",
              qualification: result?.qualification,
            };

            const coordinators = defaultValues?.coordinatorId;
            const filePath = defaultValues?.filepath;
            const extension = filePath
              ?.substring(filePath?.lastIndexOf(".") + 1)
              .toLowerCase();
            const coordinatorsName = coordinators?.filter(
              (id) => id?.hasSelected
            );
            const coordinatorsId = coordinatorsName?.map(
              (id) => id?.coordinatorId
            );

            // setJobDesc(defaultValues?.jobDescription)
            setRemarks(defaultValues?.remarks);
            setFilePath(filePath);
            setFileExtension(extension);
            setSelectedCoordinatorsName(coordinatorsName);
            setSelectedCoordinatorsId(coordinatorsId);
            setClientName(defaultValues?.clientName);
            setPositionTitle(defaultValues?.positionDesc);
            const textOnly = defaultValues?.jobDescription.replace(/<[^>]*>/g, "");
            const cleanText = textOnly.replace(/\s+/g, "");
            setJobDescLength(cleanText.length);
            reset({
              ...defaultValues,
            });
            setValue("clientId", bindingEditJobPosting?.response?.data[0]?.clientId || "");
          }
        } else {
          console.error("Error:", response.error);
        }
      } catch (error) {
        console.error("Fetch error:", error);
        setShowLoder(false);
      } finally {
        if (editScreen) {
          setValue(
            "submittedBy",
            bindingEditJobPosting?.response?.data[0]?.submittedBy
          );
        } else {
          setValue("submittedBy", useremail);
        }
      }
    }
  };

  const dataFromAI = async () => {
    setGenerating(true);
    try {
      const payload = {
        prompt: generateAIText || "",
      };

      const response = await generateJobDescriptions(payload).unwrap();
      setBackendAi(response);
      setGenerating(false);
    } catch (error) {
      console.error("API error:", error);
      Snackbar("Network Error", "error");
      setGenerating(false);
    }
  };

  const handleCopyAI = async () => {
    const md =
      typeof backendAI === "string" ? backendAI : backendAI?.text ?? "";
    if (!md) return;

    // Render Markdown → HTML string
    const html = ReactDOMServer.renderToStaticMarkup(
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown>
    );

    try {
      await navigator.clipboard.write([
        new window.ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([md], { type: "text/plain" }), // fallback plain text
        }),
      ]);
      Snackbar("Copied Successfully!", "success");
      setCopy(true);
      setTimeout(() => setCopy(false), 2000);
    } catch (err) {
      console.error("Copy failed", err);
      await navigator.clipboard.writeText(md); // fallback
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    setIsFileChanged(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    const coordinatorName = dialogCoOrdinatorDropdown?.filter((item) =>
      selectedCoordinatorsId?.includes(item?.coordinatorId)
    );
    setSelectedCoordinatorsName(coordinatorName);
    setValue("coordinatorId", selectedCoordinatorsId);
  }, [selectedCoordinatorsId]);

  const onSubmit = async (data) => {
    try {
      // Add screen
      if (!editScreen) {
        if (
          userRole !== "admin" &&
          userRole !== "coordinator" &&
          userRole !== "recruiter"
        ) {
          Snackbar("Not Authorised for Add job", "error");
          return;
        }
        // if (!jobDescription && files?.length === 0) {
        //     Snackbar('Please enter Job description or upload file', 'error');
        //     return;
        // }
        // if (new Date(data?.openDate) > new Date(data?.closeDate)) {
        //     Snackbar('Close date should be the same as or later than open date', 'error');
        //     return;
        // }
        const payload = {
          positionId: "",
          coordinatorId: selectedCoordinatorsId || [],
          clientId: data?.clientId || "",
          positionStatus: data?.positionStatus || "Pending",
          positionDesc: data?.positionDesc || "",
          positionType: data?.positionType || "",
          jobDesc: data?.jobDescription || "",
          jobLocation: data?.jobLocation || "",
          rewardAmount: !data?.rewardsRs ? null : +data?.rewardsRs,
          rewardPct: finalSourcedBy === "BA" ? (+data?.rewardsPercent || null) : null,
          openDate: "",
          priority: data?.priority || "",
          remarks: remarks || "",
          positionCount: +data?.positionCount ?? "",
          minExperience: +data?.minExperience ?? "",
          closeDate: null,
          isFile: isFileChanged,
          feedBack: data?.feedBack || "",
          rewardType: finalSourcedBy === "BA" ? (!data?.rewardType ? "" : isCost ? "FC" : "FP") : "",
          budgetedCost: +data?.budgetCost,
          budgetUnit: data?.periodOfTime,
          budgetCurrency: data?.units,
          jobTypeCode: data?.workLocation,
          primarySkills: data?.primarySkill,
          secondarySkills: data?.secondarySkill,
          qualification: data?.qualification,
          candidateRewardType: !data?.candidateRewardType
            ? "FP"
            : isCanCost
              ? "FC"
              : "FP",
          candidateRewardAmount: !data?.candidateRewardAmount
            ? null
            : +data?.candidateRewardAmount,
          candidateRewardPercentage: !data?.candidateRewardPercentage && positionType === "Contract" ?
            75 : !data?.candidateRewardPercentage ? 35
              : +data?.candidateRewardPercentage,
          submittedBy: data?.submittedBy,
          workCategoryId: data?.category || selectedKeywordIds,
          jobPositionLevelId: data?.level || selectedlevelIds,
        };

        const formData = new FormData();
        const lastIndex = files?.length - 1;

        // if (files?.length > 0) {
        //     files?.forEach((file) => {
        //         formData.append('file', file)
        //     })
        // }

        formData.append("file", files[lastIndex]);
        formData.append("addJob", JSON.stringify(payload));

        const token = localStorage.getItem("token");
        setShowLoder(true);
        const response = await fetch(window.REACT_APP_BASE_URL + `addJob`, {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const result = await response.json();
        console.log("result", result);
        if (result?.status === 200) {
          setShowLoder(false);
          if (result?.response?.message === "Job added successfully") {
            Snackbar("Data Saved Sucessfully", "success");
            navigate(isReferrals ? "/referrals" : "/jobpost");
          } else if (result?.response?.status === "error") {
            Snackbar(result?.response?.meassage, "error")
            setShowLoder(false);
          } else {
            Snackbar("Failed to add job", "error");
            setShowLoder(false);
          }
        }
      }
      // Edit screen
      else {
        // if (new Date(data?.openDate) > new Date(data?.closeDate)) {
        //     Snackbar('Close date should be the same as or later than open date', 'warning');
        //     return;
        // }

        const payload = {
          positionId: positionId || "",
          positionType: data?.positionType || "",
          clientId: data?.clientId ?? "",
          coordinatorId: selectedCoordinatorsId || [],
          positionDesc: data?.positionDesc || "",
          positionCount: +data?.positionCount ?? "",
          jobDesc: data?.jobDescription || "",
          jobLocation: data?.jobLocation || "",
          minExperience: +data?.minExperience ?? "",
          rewardAmount: !data?.rewardsRs ? null : +data?.rewardsRs,
          rewardPct: finalSourcedBy === "BA" ? (+data?.rewardsPercent || null) : null,
          openDate: data?.openDate
            ? dayjs(data?.openDate).format("DD-MM-YYYY")
            : "",
          closeDate: data?.closeDate
            ? dayjs(data?.closeDate).format("DD-MM-YYYY")
            : null,
          priority: data?.priority || "",
          positionStatus: data?.positionStatus || "",
          remarks: remarks || "",
          isFile: isFileChanged,
          feedBack: data?.feedBack || "",
          rewardType: finalSourcedBy === "BA" ? (!data?.rewardType ? "" : isCost ? "FC" : "FP") : "",
          budgetedCost: +data?.budgetCost,
          budgetUnit: data?.periodOfTime,
          budgetCurrency: data?.units,
          jobTypeCode: data?.workLocation,
          primarySkills: data?.primarySkill,
          secondarySkills: data?.secondarySkill,
          qualification: data?.qualification,
          candidateRewardType: !data?.candidateRewardType
            ? "FP"
            : isCanCost
              ? "FC"
              : "FP",
          candidateRewardAmount: !data?.candidateRewardAmount
            ? null
            : +data?.candidateRewardAmount,
          candidateRewardPercentage: isCanCost ? null : !data?.candidateRewardPercentage && positionType === "Contract"
            ? 75 : !data?.candidateRewardPercentage ? 35
              : +data?.candidateRewardPercentage,
          submittedBy: data?.submittedBy,
          workCategoryId: data?.category || selectedKeywordIds,
          jobPositionLevelId: data?.level || selectedlevelIds,
        };

        const formData = new FormData();
        const lastIndex = files?.length - 1;

        if (files?.length > 0) {
          // files?.forEach((file) => {
          //     formData?.append('file', file)
          // })
          formData.append("file", files[lastIndex]);
        } else {
          formData?.append("file", "");
        }
        formData.append("addJob", JSON.stringify(payload));

        setShowLoder(true);
        const token = localStorage.getItem("token");
        const response = await fetch(window.REACT_APP_BASE_URL + `addJob`, {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response?.ok) {
          setShowLoder(true);
          const result = await response.json();
          if (result?.response?.error) {
            Snackbar(result?.response?.error, "error");
            setShowLoder(false);
          } else if (result?.response?.status === "error") {
            Snackbar(result?.response?.meassage, "error")
            setShowLoder(false);
          } else if (result?.status === 200) {
            Snackbar("Data Updated Sucessfully", "success");
            navigate(isReferrals ? "/referrals" : "/jobpost");
          }
        } else {
          Snackbar("Failed to add job", "error");
          setShowLoder(false);
        }
      }
    } catch (err) {
      Snackbar("Network error", "error");
      setShowLoder(false);
    }
  };

  const handleFileDownload = () => {
    const extension = fileExtension;
    const name = filePath?.substring(filePath?.lastIndexOf("/") + 1);
    // const firstSlashIndex = filePath?.indexOf('/')
    // const secondSlashIndex = filePath?.indexOf('/', firstSlashIndex + 1)
    const path = filePath;

    if (extension === "doc" || extension === "docx") {
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (extension === "pdf") {
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      window.open(url, "_blank");
    } else {
      Snackbar("Unable to download file", "error");
    }
  };

  const positionTypeOptions = [
    {
      id: "Permanent",
      label: "Permanent",
    },
    {
      id: "Contract",
      label: "Contract",
    },
    {
      id: "Contract-to-Hire",
      label: "Contract-to-Hire",
    },
    {
      id: "Gig Worker",
      label: "Gig Worker",
    },
  ];

  const statusOptions = [
    {
      id: "Active",
      label: "Approved",
    },
    {
      id: "Inactive",
      label: "Rejected",
    },
    {
      id: "Closed",
      label: "Closed",
    },
    {
      id: "Hold by client",
      label: "Hold by client",
    },
    {
      id: "Dropped by 3Edge",
      label: "Dropped by 3Edge",
    },
    {
      id: "Pending",
      label: "Pending",
    },
  ];

  const rewardTypes = [
    {
      id: 1,
      label: "Fixed Amount",
    },
    {
      id: 2,
      label: "Fixed Percentage",
    },
  ];

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
  ];

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }], // only H1, H2
      ["bold", "italic", "underline"], // only bold, italic, underline
      [{ list: "ordered" }, { list: "bullet" }], // lists
      ["link"], // links only
      ["clean"], // clear formatting
    ],
  };

  const filteredStatusOptions = isReferrals
    ? statusOptions.filter(
      (option) =>
        option.id === "Active" ||
        option.id === "Inactive" ||
        option.id === "Pending" ||
        option.id === "Hold by client" ||
        option.id === "Dropped by 3E"
    )
    : statusOptions;

  const selectedStatus = watch("positionStatus");

  useEffect(() => {
    if (editScreen) {
      setStatus(true);
    }
  }, [editScreen]);

  useEffect(() => {
    if (selectedStatus === "Inactive") {
      setIsFeedback(true);
    } else {
      setIsFeedback(false);
    }
  }, [selectedStatus, watch]);

  const priorityOptions = [
    {
      id: "High",
      label: "High",
    },
    {
      id: "Medium",
      label: "Medium",
    },
    {
      id: "Low",
      label: "Low",
    },
  ];
  const workLocationOptions = [
    {
      id: "OS",
      label: "Onsite",
    },
    {
      id: "R",
      label: "Remote",
    },
    {
      id: "H",
      label: "Hybrid",
    },
  ];

  const handleNavigateback = (item) => {
    // if (isReferrals) {
    //     navigate('/referrals')
    // } else if (isReferJob) {
    //     navigate('/refer-jobs')
    // } else {
    //     navigate('/jobpost')
    // }
    navigate(-1);
  };

  const handleCancel = () => {
    if (isReferrals) {
      navigate("/referrals");
    } else if (isReferJob) {
      navigate("/refer-jobs");
    } else {
      navigate("/jobpost");
    }
  };

  const formattedOption = useMemo(() => {
    return (getDropdownDatas?.response?.userList || []).map(
      (item) => ({
        ...item,
        label: (
          <span>
            {item?.userFullName}{" "}
            <span style={{ fontSize: "12px", color: "#7F56D9" }}>
              ({item?.roleName})
            </span>
          </span>
        ),
      })
    );
  }, [getDropdownDatas]);

  const submittedBy = watch("submittedBy");
  useEffect(() => {
    const finalSubmittedBy = formattedOption?.find((item) => item?.userEmail === submittedBy)?.roleName;
    setFinalSourcedBy(finalSubmittedBy);
    if (editScreen) return;

    const canPercentage = positionType === "Contract" ? 75 : 35;
    if (getValues("candidateRewardPercentage") !== canPercentage) {
      setValue("candidateRewardPercentage", canPercentage);
    }
    if (getValues("candidateRewardType") !== 2) {
      setValue("candidateRewardType", 2);
    }

    if (finalSubmittedBy === "BA") {
      if (getValues("rewardType") !== 2) setValue("rewardType", 2);
      const jobPercentage = positionType === "Contract" ? 6 : 20;
      if (getValues("rewardsPercent") !== jobPercentage) {
        setValue("rewardsPercent", jobPercentage);
      }
    } else {
      if (getValues("rewardType") !== "") setValue("rewardType", "");
      if (getValues("rewardsPercent") !== "") setValue("rewardsPercent", "");
    }
  }, [submittedBy, formattedOption, positionType, editScreen, getValues]);

  return (
    <Box className="container">
      {showLoder ? <Loader /> : ""}
      {generating ? <GeminiLoader /> : ""}
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* 1st Box Add and Edit job */}
        <Box>
          {showLoader ? <DocumentLoader /> : ""}
          <Grid2
            item
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              color: "#6941C6",
              gap: "4px",
              marginBottom: "20px",
              justifyContent: "space-between",
            }}
          >
            <Grid2
              onClick={handleNavigateback}
              sx={{ display: "flex", cursor: "pointer" }}
              gap={1}
            >
              <ArrowBackIcon sx={{ fontSize: "17px" }} />
              <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                Back
              </Typography>
            </Grid2>
            <Grid2
              sx={{
                background:
                  "linear-gradient(270deg, #7f3beb, #a072f1, #a072f1)",
                backgroundSize: "400% 400%",
                color: "white",
                display: "flex",
                borderRadius: "12px",
                cursor: "pointer",
                alignItems: "center",
                gap: "5px",
                transition: "all 0.3s ease",
                animation: "gradientShift 6s ease infinite",
                padding: "5px",

                // "&:hover img": {
                //   transform: "rotate(360deg)",
                //   transition: "transform 1s ease-in-out",
                // },

                // "@keyframes gradientShift": {
                //   "0%": { backgroundPosition: "0% 50%" },
                //   "50%": { backgroundPosition: "100% 50%" },
                //   "100%": { backgroundPosition: "0% 50%" },
                // },
              }}
              onClick={() => setOpen(true)}
            >
              <Box
                component="img"
                src={geminiLogo}
                sx={{
                  height: "30px",
                  width: "30px",
                }}
              />

              <Typography
                sx={{
                  fontWeight: "bold",
                  fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
                  fontSize: "16px",
                  letterSpacing: "0.3px",
                  display: "inline-block",
                }}
              >
                Generate Job Description
              </Typography>
            </Grid2>
          </Grid2>
          <Typography className="title" sx={{ marginLeft: "10%" }}>
            {editScreen ? "Edit Job" : "Add Job"}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box className="formBox">
              <Typography
                sx={{ fontWeight: 600, fontSize: "17px", color: "#414651" }}
              >
                Job Description
              </Typography>
              <Grid2 item sx={{ flexGrow: 1 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid #E9EAEB",
                      height: "130px",
                      width: "100%",
                    }}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                  >
                    <input
                      type="file"
                      id="fileInput"
                      style={{ marginBottom: "15px", display: "none" }}
                      onChange={handleFileChange}
                      accept=".pdf, .doc, .docx"
                    />
                    <label
                      htmlFor="fileInput"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          height: "45px",
                          width: "43px",
                          borderRadius: "10px",
                          border: "1px solid #E9EAEB",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <UploadCloudIcon />
                      </div>
                      <Typography sx={{ color: "#535862", fontSize: "14px" }}>
                        {" "}
                        <span
                          style={{
                            color: "#6941C6",
                            fontWeight: 600,
                            fontSize: "14px",
                          }}
                        >
                          {" "}
                          Click to Upload{" "}
                        </span>{" "}
                        or drag and drop
                      </Typography>
                      <Typography
                        sx={{
                          color: "#535862",
                          fontSize: "14px",
                          marginTop: "4px",
                        }}
                      >
                        PDF, DOC, DOCX
                      </Typography>
                    </label>
                  </div>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {files?.length !== 0 && (
                      <DescriptionIcon
                        sx={{
                          color: files[files?.length - 1]?.name?.endsWith("pdf")
                            ? "#F40009"
                            : "#0039a6",
                        }}
                      />
                    )}
                    <Typography sx={{ fontSize: "14px", color: "#535862" }}>
                      {files[files?.length - 1]?.name}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {filePath !== null && files?.length === 0 && (
                      <DescriptionIcon
                        sx={{
                          color:
                            fileExtension === "pdf" ? "#F40009" : "#0039a6",
                        }}
                      />
                    )}
                    <span
                      onClick={handleFileDownload}
                      style={{
                        fontSize: "14px",
                        color: "#6941C6",
                        textDecoration: "none",
                        marginTop: "3px",
                        cursor: "pointer",
                      }}
                    >
                      <Tooltip
                        slotProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#0A0D12",
                              borderRadius: "8px",
                              padding: "8px 12px",
                              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                            },
                          },
                        }}
                        title={
                          fileExtension === "pdf"
                            ? "Click to Open"
                            : "Click to Download"
                        }
                        arrow
                      >
                        {files?.length === 0 &&
                          filePath?.substring(filePath?.lastIndexOf("/") + 1)}
                      </Tooltip>
                    </span>
                  </Box>
                </div>
              </Grid2>

              <Grid2
                item
                container
                rowGap={2}
                sx={{
                  display: !isSmallcreen ? "flex" : "",
                  justifyContent: "space-between",
                  flexDirection: isSmallcreen && "column",
                  marginTop: "20px",
                }}
              >
                <Grid2
                  item
                  sx={{
                    alignItems: "center",
                    width: !isSmallcreen ? "43%" : "100%",
                  }}
                >
                  <InputLabel className="addJobPostingInput">
                    Client Name <span style={{ color: "red" }}>*</span>{" "}
                  </InputLabel>
                  <Box sx={{ flex: 1 }}>
                    <Controller
                      name="clientId"
                      control={control}
                      render={({ field }) => {
                        const clientList = getClientDropdown?.response?.clientList || [];
                        const selectedClient =
                          clientList.find(c => c?.clientId?.toString() === field.value?.toString()) || null;

                        return (
                          <Autocomplete
                            options={clientList}
                            value={selectedClient}
                            getOptionLabel={(option) => option?.clientName || ""}
                            onChange={(_, newValue) => {
                              field.onChange(newValue ? newValue.clientId : "");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select Client"
                                variant="outlined"
                                size="small"
                                error={!!errors?.clientId}
                                helperText={errors?.clientId?.message}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "10px",
                                  },
                                  "& input": {
                                    fontSize: "14px",
                                    padding: "6px 8px",
                                  },
                                }}
                              />
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option?.clientId === value?.clientId
                            }
                            disabled={editScreen}
                            popupIcon={<KeyboardArrowDownIcon />}
                            clearIcon={<ClearIcon />}
                            renderOption={(props, option) => (
                              <li {...props} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span>{option?.clientName}</span>
                                {option?.clientId === +field.value && <DoneIcon fontSize="small" />}
                              </li>
                            )}
                            ListboxProps={{
                              style: {
                                maxHeight: 500,
                                minHeight: 200,
                              },
                            }}
                          />
                        );
                      }}
                    />
                  </Box>
                </Grid2>

                <Grid2
                  item
                  sx={{
                    alignItems: "center",
                    width: !isSmallcreen ? "43%" : "100%",
                  }}
                >
                  <InputLabel className="addJobPostingInput">
                    Position Type <span style={{ color: "red" }}>*</span>{" "}
                  </InputLabel>
                  <Box sx={{ flex: 1 }}>
                    <Controller
                      control={control}
                      name={"positionType"}
                      render={({ field }) => (
                        <Select
                          {...field}
                          size="small"
                          className="dropdown"
                          displayEmpty
                          open={openPostionType}
                          onOpen={() => setOpenPostionType(true)}
                          onClose={() => setOpenPostionType(false)}
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: errors?.positionType ? "red" : "inherit",
                              marginLeft: "-1px",
                            },
                            "& .MuiSelect-select.Mui-disabled": {
                              cursor: "not-allowed",
                            },
                            borderRadius: "10px",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <p style={{ color: "#a2a2a2" }}>
                                  {" "}
                                  Select Position Type{" "}
                                </p>
                              );
                            } else {
                              const selectedItem = positionTypeOptions?.find(
                                (name) => name?.label === selected
                              );
                              return selectedItem ? selectedItem?.label : "";
                            }
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <MenuItem value="" disabled>
                              <span className="menuItemsPlaceholder">
                                {" "}
                                Select Position type{" "}
                              </span>
                            </MenuItem>
                            <Tooltip title={"Close"} arrow>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setOpenPostionType(false);
                                }}
                              >
                                <ClearIcon
                                  sx={{ fontSize: "18px", color: "#a2a2a2" }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                          {positionTypeOptions?.map((option) => (
                            <MenuItem
                              className="menuitems"
                              key={option?.id}
                              value={option?.label}
                            >
                              {option?.label}
                              {field.value === option?.label && (
                                <DoneIcon className="doneIcon" />
                              )}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                    {errors?.positionType?.message && (
                      <div style={{ color: "red", fontSize: "0.7rem" }}>
                        {errors?.positionType?.message}
                      </div>
                    )}
                  </Box>
                </Grid2>

                <Grid2
                  item
                  sx={{
                    alignItems: "center",
                    width: !isSmallcreen ? "43%" : "100%",
                  }}
                >
                  <InputLabel className="addJobPostingInput">
                    Position Name <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    control={control}
                    name={"positionDesc"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        size="small"
                        type="text"
                        sx={{
                          flex: 1,
                          "& .MuiFormHelperText-root": {
                            color: errors?.positionDesc ? "red" : "inherit",
                            marginLeft: "-1px",
                          },
                          "& .MuiInputBase-input.Mui-disabled": {
                            cursor: "not-allowed",
                          },
                        }}
                        placeholder="Enter Position Name"
                        helperText={
                          errors?.positionDesc
                            ? errors?.positionDesc?.message
                            : ""
                        }
                      />
                    )}
                  />
                </Grid2>

                <Grid2
                  item
                  sx={{
                    alignItems: "center",
                    width: !isSmallcreen ? "43%" : "100%",
                  }}
                >
                  <InputLabel className="addJobPostingInput">
                    Number of Positions <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Controller
                      control={control}
                      name={"positionCount"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          size="small"
                          placeholder="Enter No of Positions"
                          min={0}
                          sx={{
                            flex: 1,
                            "& .MuiFormHelperText-root": {
                              color: errors?.positionCount ? "red" : "inherit",
                              marginLeft: "-1px",
                            },
                            "& .MuiInputBase-input.Mui-disabled": {
                              cursor: "not-allowed",
                            },
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                          }}
                          helperText={
                            errors?.positionCount
                              ? errors?.positionCount?.message
                              : ""
                          }
                          type="number"
                          onWheel={(e) => e.target.blur()}
                        />
                      )}
                    />
                  </div>
                </Grid2>
              </Grid2>

              <InputLabel sx={{ color: "#414651", marginTop: "10px" }}>
                Job Description <span style={{ color: "red" }}>*</span>
              </InputLabel>
              <Grid2 item sx={{ flexGrow: 1 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Controller
                    control={control}
                    name="jobDescription"
                    render={({ field }) => (
                      <ReactQuill
                        {...field}
                        value={field.value || ""}
                        onChange={(val) => {
                          field.onChange(val);
                          const textOnly = val.replace(/<[^>]*>/g, "");
                          const cleanText = textOnly.replace(/\s+/g, "");
                          setJobDescLength(cleanText.length);
                        }}

                        placeholder="Enter Job Description"
                        modules={{ toolbar: false }}
                        style={{
                          height: "300px",
                          marginTop: "5px",
                          maxHeight: "300px",
                          overflowY: "auto",
                          borderRadius: "8px",
                          border: "1px solid #ccc",
                        }}
                      />
                    )}
                  />
                </div>
                {errors?.jobDescription?.message && (
                  <div style={{ color: "red", fontSize: "0.7rem" }}>
                    {errors?.jobDescription?.message}
                  </div>
                )}
                {!errors?.jobDescription?.message && (
                  <p
                    style={{
                      fontSize: "12px",
                      color: jobDescLength >= maxLength ? "red" : "#666",
                    }}
                  >
                    Maximum of {maxLength} characters allowed. You have{" "}
                    {maxLength - jobDescLength} characters remaining
                  </p>
                )}
              </Grid2>

              <Grid2
                item
                container
                sx={{
                  display: !isSmallcreen ? "flex" : "",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="addJobPostingInput">
                      Job Location(s) <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"jobLocation"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          size="small"
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: errors?.jobLocation ? "red" : "inherit",
                              marginLeft: "-1px",
                            },
                            "& .MuiInputBase-input.Mui-disabled": {
                              cursor: "not-allowed",
                            },
                          }}
                          placeholder="Enter Job Location(s)"
                          helperText={
                            errors?.jobLocation
                              ? errors?.jobLocation?.message
                              : ""
                          }
                        />
                      )}
                    />
                  </Box>
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="addJobPostingInput">
                      Min.Experience(year){" "}
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"minExperience"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="number"
                          className="textfields"
                          size="small"
                          sx={{
                            flex: 1,
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                            "& .MuiFormHelperText-root": {
                              color: errors?.minExperience ? "red" : "inherit",
                              marginLeft: "-1px",
                            },

                            "& .MuiInputBase-input.Mui-disabled": {
                              cursor: "not-allowed",
                            },
                          }}
                          placeholder="Enter Min.Experience(year)"
                          helperText={
                            errors?.minExperience
                              ? errors?.minExperience?.message
                              : ""
                          }
                          onWheel={(e) => e.target.blur()}
                        />
                      )}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="addJobPostingInput">
                      Primary Skill <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"primarySkill"}
                      render={({ field }) => (
                        <>
                          <TextField
                            {...field}
                            type="text"
                            className="textfields"
                            size="small"
                            error={!!errors?.primarySkill}
                            inputProps={{ maxLength: 300 }}
                            sx={{
                              "& .MuiFormHelperText-root": {
                                color: errors?.primarySkill ? "red" : "inherit",
                                marginLeft: "-1px",
                              },
                              "& .MuiInputBase-input.Mui-disabled": {
                                cursor: "not-allowed",
                              },
                            }}
                            placeholder="Enter Primary Skill"
                            helperText={
                              errors?.primarySkill
                                ? errors?.primarySkill?.message
                                : ""
                            }
                          />
                          <p
                            style={{
                              fontSize: "12px",
                              color: (field.value?.length || 0) >= 300 ? "red" : "#666",
                              margin: "4px 0 0 0",
                            }}
                          >
                            {300 - (field.value?.length || 0)} characters remaining (300 characters maximum)
                          </p>
                        </>
                      )}
                    />
                  </Box>
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="addJobPostingInput">
                      Secondary Skill
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"secondarySkill"}
                      render={({ field }) => (
                        <>
                          <TextField
                            {...field}
                            className="textfields"
                            size="small"
                            error={!!errors?.secondarySkill}
                            inputProps={{ maxLength: 300 }}
                            sx={{
                              "& .MuiFormHelperText-root": {
                                color: errors?.secondarySkill ? "red" : "inherit",
                                marginLeft: "-1px",
                              },
                              "& .MuiInputBase-input.Mui-disabled": {
                                cursor: "not-allowed",
                              },
                            }}
                            placeholder="Enter Secondary Skill"
                            helperText={
                              errors?.secondarySkill
                                ? errors?.secondarySkill?.message
                                : ""
                            }
                          />
                          <p
                            style={{
                              fontSize: "12px",
                              color: (field.value?.length || 0) >= 300 ? "red" : "#666",
                              margin: "4px 0 0 0",
                            }}
                          >
                            {300 - (field.value?.length || 0)} characters remaining (300 characters maximum)
                          </p>
                        </>
                      )}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  {!editScreen ? (
                    <></>
                  ) : (
                    <Grid2 item sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                      <InputLabel className="addJobPostingInput">
                        Open Date <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Controller
                        control={control}
                        name={"openDate"}
                        render={({ field }) => (
                          <MuiDatePicker
                            {...field}
                            onChange={(date) => {
                              field.onChange(date);
                              setValue("closeDate", null); // Reset closeDate when openDate changes
                            }}
                            slotProps={{
                              textField: {
                                helperText: errors?.openDate
                                  ? errors?.openDate?.message
                                  : "",
                                placeholder: "Select Open Date",
                              },
                            }}
                          />
                        )}
                      />
                    </Grid2>
                  )}

                  {!editScreen ? (
                    <></>
                  ) : (
                    <Grid2 item sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                      <InputLabel className="addJobPostingInput">
                        Closed Date
                      </InputLabel>
                      <Controller
                        control={control}
                        name={"closeDate"}
                        render={({ field }) => (
                          <MuiDatePicker
                            {...field}
                            disabled={!watch("openDate")} // Disable if openDate is not selected
                            minDate={watch("openDate")} // Set minDate to openDate
                            slotProps={{
                              textField: {
                                helperText:
                                  errors?.closeDate && watch("openDate")
                                    ? errors?.closeDate?.message
                                    : "",
                                placeholder: "Select Close Date",
                              },
                            }}
                          />
                        )}
                      />
                    </Grid2>
                  )}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="addJobPostingInput">
                      Priority <span style={{ color: "red" }}>*</span>{" "}
                    </InputLabel>
                    <Box>
                      <Controller
                        control={control}
                        name={"priority"}
                        render={({ field }) => (
                          <Select
                            {...field}
                            size="small"
                            className="dropdown"
                            displayEmpty
                            open={openPriority}
                            onOpen={() => setOpenPriority(true)}
                            onClose={() => setOpenPriority(false)}
                            sx={{
                              "& .MuiFormHelperText-root": {
                                color: errors?.priority ? "red" : "inherit",
                                marginLeft: "-1px",
                              },
                              "& .MuiSelect-select.Mui-disabled": {
                                cursor: "not-allowed",
                              },
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <p style={{ color: "#a2a2a2" }}>
                                    Select Priority
                                  </p>
                                );
                              } else {
                                const selectedItem = priorityOptions?.find(
                                  (name) => name?.label === selected
                                );
                                return selectedItem ? selectedItem?.label : "";
                              }
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <MenuItem value="" disabled>
                                <span className="menuItemsPlaceholder">
                                  {" "}
                                  Select Priority{" "}
                                </span>
                              </MenuItem>
                              <Tooltip title={"Close"} arrow>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setOpenPriority(false);
                                  }}
                                >
                                  <ClearIcon
                                    sx={{ fontSize: "18px", color: "#a2a2a2" }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </Box>
                            {priorityOptions?.map((option) => (
                              <MenuItem
                                key={option?.id}
                                value={option?.label}
                                className="menuitems"
                              >
                                {option?.label}
                                {field.value === option.label && (
                                  <DoneIcon className="doneIcon" />
                                )}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      {errors?.priority?.message && (
                        <div style={{ color: "red", fontSize: "0.7rem" }}>
                          {errors?.priority?.message}
                        </div>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="addJobPostingInput">
                      {" "}
                      Qualification
                    </InputLabel>
                    <Controller
                      control={control}
                      name={"qualification"}
                      render={({ field }) => (
                        <>
                          <TextField
                            {...field}
                            type="text"
                            className="textfields"
                            size="small"
                            error={!!errors?.qualification}
                            inputProps={{ maxLength: 300 }}
                            sx={{
                              flex: 1,
                              "& .MuiFormHelperText-root": {
                                color: errors?.qualification ? "red" : "inherit",
                                marginLeft: "-1px",
                              },
                              "& .MuiInputBase-input.Mui-disabled": {
                                cursor: "not-allowed",
                              },
                              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                              {
                                display: "none",
                              },
                              "& input[type=number]": {
                                MozAppearance: "textfield",
                              },
                            }}
                            placeholder="Enter Qualifications"
                            onWheel={(e) => e.target.blur()}
                          />
                          {
                            <span style={{ color: "red", fontSize: "0.7rem", display: "block", marginTop: "4px" }}>
                              {" "}
                              {errors?.qualification
                                ? errors?.qualification?.message
                                : ""}
                            </span>
                          }
                          <p
                            style={{
                              fontSize: "12px",
                              color: (field.value?.length || 0) >= 300 ? "red" : "#666",
                              margin: "4px 0 0 0",
                            }}
                          >
                            {300 - (field.value?.length || 0)} characters remaining (300 characters maximum)
                          </p>
                        </>
                      )}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="addJobPostingInput">
                      Work Mode <span style={{ color: "red" }}>*</span>{" "}
                    </InputLabel>
                    <Box sx={{ flex: 1 }}>
                      <Controller
                        control={control}
                        name={"workLocation"}
                        render={({ field }) => (
                          <Select
                            {...field}
                            size="small"
                            className="dropdown"
                            placeholder="Work Mode"
                            open={openWorkmode}
                            onOpen={() => setOpenWorkmode(true)}
                            onClose={() => setOpenWorkmode(false)}
                            displayEmpty
                            sx={{
                              "& .MuiFormHelperText-root": {
                                marginLeft: "-1px",
                              },
                              "& .MuiSelect-select.Mui-disabled": {
                                cursor: "not-allowed",
                              },
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <p style={{ color: "#a2a2a2" }}>
                                    Select Work Mode
                                  </p>
                                );
                              } else {
                                const selectedItem = workLocationOptions?.find(
                                  (option) => option.id === selected
                                );
                                return selectedItem ? selectedItem?.label : "";
                              }
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <MenuItem value="" disabled>
                                <span className="menuItemsPlaceholder">
                                  {" "}
                                  Select Work Mode{" "}
                                </span>
                              </MenuItem>
                              <Tooltip title={"Close"} arrow>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setOpenWorkmode(false);
                                  }}
                                >
                                  <ClearIcon
                                    sx={{ fontSize: "18px", color: "#a2a2a2" }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </Box>
                            {workLocationOptions?.map((option) => (
                              <MenuItem
                                key={option?.id}
                                value={option?.id}
                                className="menuitems"
                              >
                                {option?.label}
                                {field.value === option.label && (
                                  <DoneIcon className="doneIcon" />
                                )}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      {errors?.workLocation?.message && (
                        <div style={{ color: "red", fontSize: "0.7rem" }}>
                          {errors?.workLocation?.message}
                        </div>
                      )}
                    </Box>
                  </Box>

                  <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                    <InputLabel className="addJobPostingInput">
                      {positionType === "Contract" ? "Maximum Billing Amount" : "Maximum Budgeted Cost"}
                    </InputLabel>
                    <Grid2
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: "10px",
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <Controller
                          control={control}
                          name={"budgetCost"}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              type="number"
                              className="textfields"
                              size="small"
                              sx={{
                                flex: 1,
                                "& .MuiFormHelperText-root": {
                                  color: errors?.budgetCost ? "red" : "inherit",
                                  marginLeft: "-1px",
                                },
                                "& .MuiInputBase-input.Mui-disabled": {
                                  cursor: "not-allowed",
                                },
                                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                {
                                  display: "none",
                                },
                                "& input[type=number]": {
                                  MozAppearance: "textfield",
                                },
                              }}
                              placeholder={positionType === "Contract" ? "Billing Amount" : "Budgeted Cost"}
                              helperText={
                                errors?.budgetCost
                                  ? errors?.budgetCost?.message
                                  : ""
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          )}
                        />
                      </Box>
                      <Box sx={{ width: "100%" }}>
                        <Controller
                          control={control}
                          name={"units"}
                          render={({ field }) => (
                            <Select
                              {...field}
                              size="small"
                              className="dropdown"
                              displayEmpty
                              sx={{
                                "& .MuiSelect-select.Mui-disabled": {
                                  cursor: "not-allowed",
                                },
                              }}
                              onChange={(event) => {
                                field.onChange(event.target.value);
                              }}
                            >
                              <MenuItem value="" disabled>
                                <span className="menuItemsPlaceholder">
                                  Currency
                                </span>
                              </MenuItem>
                              {units.map((option) => (
                                <MenuItem
                                  key={option.id}
                                  value={option.label}
                                  className="menuitems"
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                        {errors?.units?.message && (
                          <div style={{ color: "red", fontSize: "0.7rem" }}>
                            {errors.units.message}
                          </div>
                        )}
                      </Box>
                      <Box sx={{ width: "100%" }}>
                        <Controller
                          control={control}
                          name={"periodOfTime"}
                          render={({ field }) => (
                            <Select
                              {...field}
                              size="small"
                              className="dropdown"
                              displayEmpty
                              sx={{
                                "& .MuiSelect-select.Mui-disabled": {
                                  cursor: "not-allowed",
                                },
                              }}
                              onChange={(event) => {
                                field.onChange(event.target.value);
                              }}
                            >
                              <MenuItem value="" disabled>
                                <span className="menuItemsPlaceholder">
                                  Units
                                </span>
                              </MenuItem>
                              {periodOfTime.map((option) => (
                                <MenuItem
                                  key={option.id}
                                  value={option.id}
                                  className="menuitems"
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                        {errors?.periodOfTime?.message && (
                          <div style={{ color: "red", fontSize: "0.7rem" }}>
                            {errors.periodOfTime.message}
                          </div>
                        )}
                      </Box>

                    </Grid2>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  <Grid2
                    item
                    sx={{
                      width: !isSmallcreen ? "40%" : "100%",
                    }}
                  >
                    <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                      Select Work Category{" "}
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <Controller
                        control={control}
                        name="category"
                        render={({ field }) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap", // optional
                              gap: 2,
                            }}
                          >
                            {getWorkCategoryDropDown?.response.map((option) => (
                              <Box
                                key={option.workCategoryId}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  width: "40%",
                                }}
                              >
                                <span>
                                  <Radio
                                    checked={
                                      field.value === option.workCategoryId
                                    }
                                    onChange={() => {
                                      field.onChange(option.workCategoryId);
                                      setSelectedKeywordIds(
                                        option.workCategoryId
                                      );
                                    }}
                                  />
                                  {option.workCategoryName}
                                </span>
                              </Box>
                            ))}
                          </Box>
                        )}
                      />
                      {errors?.category?.message && (
                        <span style={{ color: "red", fontSize: "0.8rem" }}>
                          {errors?.category?.message}
                        </span>
                      )}
                    </Box>
                  </Grid2>

                  <Grid2
                    item
                    sx={{
                      width: !isSmallcreen ? "40%" : "100%",
                    }}
                  >
                    <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                      Select Position Level <span style={{ color: "red" }}>*</span>
                    </InputLabel>

                    <Box sx={{ width: "100%" }}>
                      <Controller
                        control={control}
                        name="level"
                        render={({ field }) => (
                          <FormControl fullWidth>
                            <Select
                              {...field}
                              value={field.value || ""} // ✅ make sure value comes from field
                              onChange={(e) => {
                                field.onChange(e.target.value); // ✅ update RHF form state
                                setSelectedlevelIds(e.target.value); // ✅ update your custom state
                              }}
                              displayEmpty
                              renderValue={(selected) =>
                                !selected ? (
                                  <span
                                    style={{
                                      color: "#a2a2a2",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Select Level
                                  </span>
                                ) : (
                                  getPositionLevelDropDown?.response.find(
                                    (level) => level.jobPositionLevelId === selected
                                  )?.jobPositionLevelName
                                )
                              }
                              sx={{
                                height: "35px",
                                fontSize: "14px",
                                borderRadius: "10px",
                              }}
                            >
                              {getPositionLevelDropDown?.response.map((option) => {
                                const isDisabled = option.isPositionLevel === "N";

                                return (
                                  <MenuItem
                                    key={option.jobPositionLevelId}
                                    // disabled={isDisabled}
                                    value={option.jobPositionLevelId}
                                    sx={{ fontSize: "14px" }}
                                  >
                                    {option.jobPositionLevelName}
                                  </MenuItem>
                                );
                              })}
                            </Select>

                            {errors?.level?.message && (
                              <span style={{ color: "red", fontSize: "0.8rem" }}>
                                {errors.level.message}
                              </span>
                            )}
                          </FormControl>
                        )}
                      />
                    </Box>
                  </Grid2>

                </Box>

                {!editScreen && userRole === "admin" && (
                  <Box
                    sx={{
                      width: !isSmallcreen ? "40%" : "100%",
                      marginTop: "10px",
                    }}
                  >
                    <InputLabel className="inputlabels">
                      Sourced By <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      name="submittedBy"
                      control={control}
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          IconComponent={KeyboardArrowDownIcon}
                          className="dropdown"
                          placeholder="Select Name"
                          displayEmpty
                          helperText={
                            errors?.submittedBy
                              ? errors?.submittedBy?.message
                              : ""
                          }
                          options={formattedOption || []}
                          valueKey="userEmail"
                          labelKey="label"
                          sx={{
                            height: "35px",
                            width: "100%",
                            fontSize: "14px",
                            "& .MuiInputBase-root": {
                              fontSize: "14px", // Apply font size to input
                            },
                          }}
                        />
                      )}
                    />
                    {errors?.submittedBy && (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {" "}
                        Email is required
                      </div>
                    )}
                  </Box>
                )}

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: !isSmallcreen ? "row" : "column",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                  rowGap={2}
                >
                  {status ? (
                    <Grid2 sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                      <InputLabel className="addJobPostingInput">
                        Status<span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Box sx={{ flex: 1 }}>
                        <Controller
                          control={control}
                          name="positionStatus"
                          render={({ field }) => (
                            <Select
                              {...field}
                              size="small"
                              className="dropdown"
                              displayEmpty
                              open={openStatus}
                              onOpen={() => setOpenStatus(true)}
                              onClose={() => setOpenStatus(false)}
                              sx={{
                                "& .MuiSelect-select.Mui-disabled": {
                                  cursor: "not-allowed",
                                },
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                              renderValue={(selected) => {
                                if (!selected) {
                                  return (
                                    <p style={{ color: "#a2a2a2" }}>
                                      Select Status
                                    </p>
                                  );
                                }
                                const selectedItem = filteredStatusOptions.find(
                                  (option) => option.id === selected
                                );
                                return selectedItem ? selectedItem.label : "";
                              }}
                              onChange={(event) => {
                                // Store the `id` value instead of `label`
                                field.onChange(event.target.value);
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <MenuItem value="" disabled>
                                  <span className="menuItemsPlaceholder">
                                    Select Status
                                  </span>
                                </MenuItem>
                                <Tooltip title={"Close"} arrow>
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      setOpenStatus(false);
                                    }}
                                  >
                                    <ClearIcon
                                      sx={{
                                        fontSize: "18px",
                                        color: "#a2a2a2",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                              {filteredStatusOptions.map((option) => (
                                <MenuItem
                                  key={option.id}
                                  value={option.id}
                                  className="menuitems"
                                >
                                  {option.label}
                                  {field.value === option.id && (
                                    <DoneIcon className="doneIcon" />
                                  )}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                        {errors?.positionStatus?.message && (
                          <div style={{ color: "red", fontSize: "0.7rem" }}>
                            {errors.positionStatus.message}
                          </div>
                        )}
                      </Box>
                    </Grid2>
                  ) : (
                    <></>
                  )}

                  {editScreen && userRole === "admin" ? (
                    <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                      <InputLabel className="inputlabels">
                        Sourced By <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Controller
                        name="submittedBy"
                        control={control}
                        render={({ field }) => (
                          <Dropdown
                            {...field}
                            IconComponent={KeyboardArrowDownIcon}
                            className="dropdown"
                            placeholder="Select Name"
                            displayEmpty
                            disabled={userRole !== "admin"}
                            helperText={
                              errors?.submittedBy
                                ? errors?.submittedBy?.message
                                : ""
                            }
                            options={formattedOption || []}
                            valueKey="userEmail"
                            labelKey="label"
                            sx={{
                              height: "35px",
                              width: "100%",
                              fontSize: "14px",
                              "& .MuiInputBase-root": {
                                fontSize: "14px", // Apply font size to input
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.submittedBy && (
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {" "}
                          Email is required
                        </div>
                      )}
                    </Box>
                  ) : (
                    <></>
                  )}
                </Box>

                {/* <Grid2 item container rowGap={2} sx={{ display: 'flex', flexDirection: 'column', width: !isSmallcreen ? '43%' : '100%' }}>
                                    <Grid2 item sx={{ alignItems: 'center' }}>
                                        <InputLabel className="addJobPostingInput">Job Location(s) <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name={"jobLocation"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="textfields"
                                                    size="small"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.jobLocation ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                            cursor: "not-allowed"
                                                        },
                                                    }}
                                                    placeholder="Enter Job Location(s)"
                                                    helperText={errors?.jobLocation ? errors?.jobLocation?.message : ""}
                                                />
                                            )}
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{ alignItems: 'center' }}>
                                        <InputLabel className="addJobPostingInput">Primary Skill <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name={"primarySkill"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type="text"
                                                    className="textfields"
                                                    size="small"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.primarySkill ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                            cursor: "not-allowed"
                                                        },
                                                    }}
                                                    placeholder="Enter Primary Skill"
                                                    helperText={errors?.primarySkill ? errors?.primarySkill?.message : ""}
                                                />
                                            )}
                                        />
                                    </Grid2>

                                    {
                                        !editScreen ? (<></>) : (
                                            <Grid2 item sx={{ alignItems: 'center' }}>
                                                <InputLabel className="addJobPostingInput">Open Date <span style={{ color: 'red' }}>*</span></InputLabel>
                                                <Controller
                                                    control={control}
                                                    name={"openDate"}
                                                    render={({ field }) => (
                                                        <MuiDatePicker
                                                            {...field}
                                                            onChange={(date) => {
                                                                field.onChange(date);
                                                                setValue('closeDate', null); // Reset closeDate when openDate changes
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    helperText: errors?.openDate ? errors?.openDate?.message : "",
                                                                    placeholder: 'Select Open Date',
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid2>
                                        )
                                    }

                                    <Grid2 item sx={{ alignItems: "center" }}>
                                        <InputLabel className="addJobPostingInput">Priority <span style={{ color: 'red' }}>*</span> </InputLabel>
                                        <Box>
                                            <Controller
                                                control={control}
                                                name={"priority"}
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        size="small"
                                                        className="dropdown"
                                                        displayEmpty
                                                        sx={{
                                                            "& .MuiFormHelperText-root": {
                                                                color: errors?.priority ? "red" : "inherit",
                                                                marginLeft: '-1px'
                                                            },
                                                            "& .MuiSelect-select.Mui-disabled": {
                                                                cursor: "not-allowed",
                                                            },
                                                        }}
                                                        IconComponent={KeyboardArrowDownIcon}
                                                        renderValue={(selected) => {
                                                            if (!selected) {
                                                                return <p style={{ color: '#a2a2a2' }}>Select Priority</p>
                                                            } else {
                                                                const selectedItem = priorityOptions?.find((name) => name?.label === selected)
                                                                return selectedItem ? selectedItem?.label : ''
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem value="" disabled><span className="menuItemsPlaceholder"> Select Priority </span></MenuItem>
                                                        {priorityOptions?.map((option) => (
                                                            <MenuItem key={option?.id} value={option?.label} className="menuitems">
                                                                {option?.label}
                                                                {field.value === option.label && (
                                                                    <DoneIcon className="doneIcon" />
                                                                )}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                )}
                                            />
                                            {errors?.priority?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.priority?.message}
                                                </div>
                                            )}
                                        </Box>
                                    </Grid2>


                                    <Grid2 item sx={{ alignItems: "center" }}>
                                        <InputLabel className="addJobPostingInput">Work Mode <span style={{ color: 'red' }}>*</span> </InputLabel>
                                        <Box sx={{ flex: 1 }}>
                                            <Controller
                                                control={control}
                                                name={"workLocation"}
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        size="small"
                                                        className="dropdown"
                                                        placeholder="Work Mode"
                                                        displayEmpty
                                                        sx={{
                                                            "& .MuiFormHelperText-root": {
                                                                marginLeft: '-1px'
                                                            },
                                                            "& .MuiSelect-select.Mui-disabled": {
                                                                cursor: "not-allowed",
                                                            },
                                                        }}
                                                        IconComponent={KeyboardArrowDownIcon}
                                                        renderValue={(selected) => {
                                                            if (!selected) {
                                                                return <p style={{ color: '#a2a2a2' }}>Select Work Mode</p>
                                                            } else {
                                                                const selectedItem = workLocationOptions?.find((option) => option.id === selected)
                                                                return selectedItem ? selectedItem?.label : ''
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem value="" disabled><span className="menuItemsPlaceholder"> Select Work Mode </span></MenuItem>
                                                        {workLocationOptions?.map((option) => (
                                                            <MenuItem key={option?.id} value={option?.id} className="menuitems">
                                                                {option?.label}
                                                                {field.value === option.label && (
                                                                    <DoneIcon className="doneIcon" />
                                                                )}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                )}
                                            />
                                            {errors?.workLocation?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.workLocation?.message}
                                                </div>
                                            )}
                                        </Box>
                                    </Grid2>

                                    {
                                        userRole !== "recruiter" && editScreen ? (
                                            <Grid2 item sx={{ alignItems: "center" }}>
                                                <InputLabel className="addJobPostingInput">Budgeted Cost</InputLabel>
                                                <Grid2 sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '10px', width: '100%' }}>
                                                    <Box sx={{ width: '100%' }}>
                                                        <Controller
                                                            control={control}
                                                            name={'budgetCost'}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    type="number"
                                                                    className="textfields"
                                                                    size="small"
                                                                    sx={{
                                                                        flex: 1,
                                                                        "& .MuiFormHelperText-root": {
                                                                            color: errors?.budgetCost ? "red" : "inherit",
                                                                            marginLeft: '-1px'
                                                                        },
                                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                                            cursor: "not-allowed"
                                                                        },
                                                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                                            display: "none",
                                                                        },
                                                                        "& input[type=number]": {
                                                                            MozAppearance: "textfield",
                                                                        },
                                                                    }}
                                                                    placeholder="Budgeted Cost"
                                                                    helperText={errors?.budgetCost ? errors?.budgetCost?.message : ""}
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                            )}
                                                        />
                                                    </Box>
                                                    <Box sx={{ width: '100%' }}>
                                                        <Controller
                                                            control={control}
                                                            name={'units'}
                                                            render={({ field }) => (
                                                                <Select
                                                                    {...field}
                                                                    size="small"
                                                                    className="dropdown"
                                                                    displayEmpty
                                                                    sx={{
                                                                        "& .MuiSelect-select.Mui-disabled": {
                                                                            cursor: "not-allowed",
                                                                        },
                                                                    }}
                                                                    onChange={(event) => {
                                                                        field.onChange(event.target.value);
                                                                    }}
                                                                >
                                                                    <MenuItem value="" disabled>
                                                                        <span className="menuItemsPlaceholder">Currency</span>
                                                                    </MenuItem>
                                                                    {units.map((option) => (
                                                                        <MenuItem key={option.id} value={option.label} className="menuitems">
                                                                            {option.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            )}
                                                        />
                                                        {errors?.units?.message && (
                                                            <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                                {errors.units.message}
                                                            </div>
                                                        )}
                                                    </Box>
                                                    <Box sx={{ width: '100%' }}>
                                                        <Controller
                                                            control={control}
                                                            name={'periodOfTime'}
                                                            render={({ field }) => (
                                                                <Select
                                                                    {...field}
                                                                    size="small"
                                                                    className="dropdown"
                                                                    displayEmpty
                                                                    sx={{
                                                                        "& .MuiSelect-select.Mui-disabled": {
                                                                            cursor: "not-allowed",
                                                                        },
                                                                    }}
                                                                    onChange={(event) => {
                                                                        field.onChange(event.target.value);
                                                                    }}
                                                                >
                                                                    <MenuItem value="" disabled>
                                                                        <span className="menuItemsPlaceholder">Unit</span>
                                                                    </MenuItem>
                                                                    {periodOfTime.map((option) => (
                                                                        <MenuItem key={option.id} value={option.id} className="menuitems">
                                                                            {option.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            )}
                                                        />
                                                        {errors?.periodOfTime?.message && (
                                                            <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                                {errors.periodOfTime.message}
                                                            </div>
                                                        )}
                                                    </Box>
                                                </Grid2>
                                            </Grid2>
                                        ) : (<></>)
                                    }




                                </Grid2> */}

                {/* sub-container 2 */}
                <Grid2
                  item
                  container
                  rowGap={userRole !== "admin" ? 1 : 2}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: !isSmallcreen ? "43%" : "100%",
                  }}
                >
                  {/* <Grid2 item sx={{ alignItems: 'center' }}>
                                        <InputLabel className="addJobPostingInput">Min.Experience(year) <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <Controller
                                            control={control}
                                            name={'minExperience'}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type="number"
                                                    className="textfields"
                                                    size="small"
                                                    sx={{
                                                        flex: 1,
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.minExperience ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                            cursor: "not-allowed"
                                                        },
                                                    }}
                                                    placeholder="Enter Min.Experience(year)"
                                                    helperText={errors?.minExperience ? errors?.minExperience?.message : ""}
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            )}
                                        />
                                    </Grid2> */}

                  {/* <Grid2 item sx={{ alignItems: 'center' }}>
                                        <InputLabel className="addJobPostingInput">Secondary Skill</InputLabel>
                                        <Controller
                                            control={control}
                                            name={"secondarySkill"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="textfields"
                                                    size="small"
                                                    sx={{
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.secondarySkill ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                            cursor: "not-allowed"
                                                        },
                                                    }}
                                                    placeholder="Enter Secondary Skill"
                                                    helperText={errors?.secondarySkill ? errors?.secondarySkill?.message : ""}
                                                />
                                            )}
                                        />
                                    </Grid2> */}

                  {/* {
                                        !editScreen ? (<></>) : (
                                            <Grid2 item sx={{ alignItems: 'center' }}>
                                                <InputLabel className="addJobPostingInput">Closed Date</InputLabel>
                                                <Controller
                                                    control={control}
                                                    name={"closeDate"}
                                                    render={({ field }) => (
                                                        <MuiDatePicker
                                                            {...field}
                                                            disabled={!watch('openDate')} // Disable if openDate is not selected
                                                            minDate={watch('openDate')} // Set minDate to openDate
                                                            slotProps={{
                                                                textField: {
                                                                    helperText: errors?.closeDate && watch('openDate') ? errors?.closeDate?.message : "",
                                                                    placeholder: 'Select Close Date',
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid2>
                                        )} */}

                  {/* <Grid2 item sx={{ alignItems: "center" }}>
                                        <InputLabel className="addJobPostingInput"> Qualification</InputLabel>
                                        <Controller
                                            control={control}
                                            name={'qualification'}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    type="text"
                                                    className="textfields"
                                                    size="small"
                                                    sx={{
                                                        flex: 1,
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.qualification ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                            cursor: "not-allowed"
                                                        },
                                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                            display: "none",
                                                        },
                                                        "& input[type=number]": {
                                                            MozAppearance: "textfield",
                                                        },
                                                    }}
                                                    placeholder="Enter Qualifications"
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            )}
                                        />
                                        {<span style={{ color: 'red', fontSize: '0.7rem' }}>  {errors?.qualification ? errors?.qualification?.message : ""}</span>}
                                    </Grid2> */}

                  {/* {status ? (
                                        <Grid2 item sx={{ alignItems: "center" }}>
                                            <InputLabel className="addJobPostingInput">
                                                Status<span style={{ color: 'red' }}>*</span>
                                            </InputLabel>
                                            <Box sx={{ flex: 1 }}>
                                                <Controller
                                                    control={control}
                                                    name="positionStatus"
                                                    render={({ field }) => (
                                                        <Select
                                                            {...field}
                                                            size="small"
                                                            className="dropdown"
                                                            displayEmpty
                                                            sx={{
                                                                "& .MuiSelect-select.Mui-disabled": {
                                                                    cursor: "not-allowed",
                                                                },
                                                            }}
                                                            IconComponent={KeyboardArrowDownIcon}
                                                            renderValue={(selected) => {
                                                                if (!selected) {
                                                                    return <p style={{ color: '#a2a2a2' }}>Select Status</p>;
                                                                }
                                                                const selectedItem = filteredStatusOptions.find((option) => option.id === selected);
                                                                return selectedItem ? selectedItem.label : '';
                                                            }}
                                                            onChange={(event) => {
                                                                // Store the `id` value instead of `label`
                                                                field.onChange(event.target.value);
                                                            }}
                                                        >
                                                            <MenuItem value="" disabled>
                                                                <span className="menuItemsPlaceholder">Select Status</span>
                                                            </MenuItem>
                                                            {filteredStatusOptions.map((option) => (
                                                                <MenuItem key={option.id} value={option.id} className="menuitems">
                                                                    {option.label}
                                                                    {field.value === option.id && <DoneIcon className="doneIcon" />}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    )}
                                                />
                                                {errors?.positionStatus?.message && (
                                                    <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                        {errors.positionStatus.message}
                                                    </div>
                                                )}
                                            </Box>
                                        </Grid2>
                                    ) : (<></>)} */}

                  {/* Edit screen */}
                  {/* {
                                        userRole !== "recruiter" && editScreen ? (
                                            <Grid2 item sx={{ alignItems: "center" }}>
                                                <InputLabel className="addJobPostingInput">Work Location <span style={{ color: 'red' }}>*</span> </InputLabel>
                                                <Box sx={{ flex: 1 }}>
                                                    <Controller
                                                        control={control}
                                                        name={"workLocation"}
                                                        render={({ field }) => (
                                                            <Select
                                                                {...field}
                                                                size="small"
                                                                className="dropdown"
                                                                placeholder="Work Location"
                                                                displayEmpty
                                                                sx={{
                                                                    "& .MuiFormHelperText-root": {
                                                                        marginLeft: '-1px'
                                                                    },
                                                                    "& .MuiSelect-select.Mui-disabled": {
                                                                        cursor: "not-allowed",
                                                                    },
                                                                }}
                                                                IconComponent={KeyboardArrowDownIcon}
                                                                renderValue={(selected) => {
                                                                    if (!selected) {
                                                                        return <p style={{ color: '#a2a2a2' }}>Select Work Location</p>
                                                                    } else {
                                                                        const selectedItem = workLocationOptions?.find((option) => option.id === selected)
                                                                        return selectedItem ? selectedItem?.label : ''
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value="" disabled><span className="menuItemsPlaceholder"> Select Work Location </span></MenuItem>
                                                                {workLocationOptions?.map((option) => (
                                                                    <MenuItem key={option?.id} value={option?.id} className="menuitems">
                                                                        {option?.label}
                                                                        {field.value === option.label && (
                                                                            <DoneIcon className="doneIcon" />
                                                                        )}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        )}
                                                    />
                                                    {errors?.workLocation?.message && (
                                                        <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                            {errors?.workLocation?.message}
                                                        </div>
                                                    )}
                                                </Box>
                                            </Grid2>

                                        ) : (<></>)
                                    } */}

                  {/* {
                                        !editScreen ? (
                                            <Grid2 item sx={{ alignItems: "center" }}>
                                                <InputLabel className="addJobPostingInput">Budgeted Cost</InputLabel>
                                                <Grid2 sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '10px', }}>
                                                    <Box sx={{ width: '100%' }}>
                                                        <Controller
                                                            control={control}
                                                            name={'budgetCost'}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    type="number"
                                                                    className="textfields"
                                                                    size="small"
                                                                    sx={{
                                                                        flex: 1,
                                                                        "& .MuiFormHelperText-root": {
                                                                            color: errors?.budgetCost ? "red" : "inherit",
                                                                            marginLeft: '-1px'
                                                                        },
                                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                                            cursor: "not-allowed"
                                                                        },
                                                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                                            display: "none",
                                                                        },
                                                                        "& input[type=number]": {
                                                                            MozAppearance: "textfield",
                                                                        },
                                                                    }}
                                                                    placeholder="Budgeted Cost"
                                                                    helperText={errors?.budgetCost ? errors?.budgetCost?.message : ""}
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                            )}
                                                        />
                                                    </Box>
                                                    <Box sx={{ width: '100%' }}>
                                                        <Controller
                                                            control={control}
                                                            name={'units'}
                                                            render={({ field }) => (
                                                                <Select
                                                                    {...field}
                                                                    size="small"
                                                                    className="dropdown"
                                                                    displayEmpty
                                                                    sx={{
                                                                        "& .MuiSelect-select.Mui-disabled": {
                                                                            cursor: "not-allowed",
                                                                        },

                                                                    }}
                                                                    onChange={(event) => {
                                                                        field.onChange(event.target.value);
                                                                    }}
                                                                >
                                                                    <MenuItem value="" disabled>
                                                                        <span className="menuItemsPlaceholder">Currency</span>
                                                                    </MenuItem>
                                                                    {units.map((option) => (
                                                                        <MenuItem key={option.id} value={option.label} className="menuitems">
                                                                            {option.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            )}
                                                        />
                                                        {errors?.units?.message && (
                                                            <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                                {errors.units.message}
                                                            </div>
                                                        )}
                                                    </Box>
                                                    <Box sx={{ width: '100%' }}>
                                                        <Controller
                                                            control={control}
                                                            name={'periodOfTime'}
                                                            render={({ field }) => (
                                                                <Select
                                                                    {...field}
                                                                    size="small"
                                                                    className="dropdown"
                                                                    displayEmpty
                                                                    sx={{
                                                                        "& .MuiSelect-select.Mui-disabled": {
                                                                            cursor: "not-allowed",
                                                                        },
                                                                    }}
                                                                    onChange={(event) => {
                                                                        field.onChange(event.target.value);
                                                                    }}
                                                                >
                                                                    <MenuItem value="" disabled>
                                                                        <span className="menuItemsPlaceholder">Units</span>
                                                                    </MenuItem>
                                                                    {periodOfTime.map((option) => (
                                                                        <MenuItem key={option.id} value={option.id} className="menuitems">
                                                                            {option.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            )}
                                                        />
                                                        {errors?.periodOfTime?.message && (
                                                            <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                                {errors.periodOfTime.message}
                                                            </div>
                                                        )}
                                                    </Box>
                                                </Grid2>
                                            </Grid2>
                                        ) : (<></>)
                                    } */}
                </Grid2>
              </Grid2>

              {selectedStatus && selectedStatus === "Inactive" && (
                <Grid2
                  container
                  rowGap={2}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "20px",
                  }}
                >
                  <Grid2
                    item
                    container
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Grid2 item sx={{ flexGrow: 1 }}>
                      <InputLabel sx={{ color: "#000000" }}>
                        {isReferrals === true ? "Reason for Reject" : "Reason"}
                        <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                        <Controller
                          control={control}
                          name="feedBack"
                          render={({ field }) => (
                            <textarea
                              {...field}
                              className="jobPostingTextAreas"
                              placeholder="Enter Reason"
                              style={{ marginTop: "5px" }}
                            />
                          )}
                        />
                        {errors?.feedBack?.message && (
                          <div style={{ color: "red", fontSize: "0.7rem" }}>
                            {errors.feedBack.message}
                          </div>
                        )}
                      </div>
                    </Grid2>
                  </Grid2>
                </Grid2>
              )}

              <Grid2
                container
                rowGap={2}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "20px",
                }}
              >
                <Grid2
                  item
                  container
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Grid2 item sx={{ flexGrow: 1 }}>
                    <InputLabel sx={{ color: "#000000" }}>Remarks</InputLabel>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <textarea
                        className="jobPostingTextAreas"
                        size="small"
                        placeholder="Enter Remarks"
                        value={remarks}
                        onChange={handleRemarksChange}
                        style={{ marginTop: "5px" }}
                      />
                    </div>
                  </Grid2>

                  {userRole === "recruiter" || isReferrals === true ? (
                    <></>
                  ) : (
                    <Grid2
                      item
                      sx={{ width: "100%", flexGrow: 1, marginTop: "20px" }}
                    >
                      <InputLabel sx={{ color: "#000000" }}>
                        Co-ordinator <span style={{ color: "red" }}>*</span>{" "}
                      </InputLabel>
                      <Select
                        open={openSelect}
                        onOpen={() => setOpenSelect(true)}
                        onClose={() => setOpenSelect(false)}
                        value={
                          selectedCoordinatorsId?.filter(
                            (id) => id !== undefined
                          ) || []
                        }
                        onChange={handleCoordinatorChange}
                        multiple
                        sx={{
                          width: "100%",
                          height: "40px",
                          fontSize: "14px",
                          borderRadius: "10px",
                        }}
                        displayEmpty
                        renderValue={(selected) =>
                          selected?.length < 1 ? (
                            <p style={{ color: "#a2a2a2", fontSize: "14px" }}>
                              Select Co-ordinator
                            </p>
                          ) : (
                            selectedCoordinatorsName
                              ?.map((item) => item?.coordinatorName)
                              ?.join(", ")
                          )
                        }
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "5px",
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() => {
                              setOpenSelect(false);
                            }}
                          >
                            <ClearIcon
                              sx={{ fontSize: "18px", color: "#a2a2a2" }}
                            />
                          </IconButton>
                        </Box>

                        <MenuItem
                          value=""
                          className="menuItemsPlaceholder"
                          disabled
                        >
                          Select Co-ordinator
                        </MenuItem>
                        {dialogCoOrdinatorDropdown?.map((item) => (
                          <MenuItem
                            key={item?.coordinatorId}
                            value={item?.coordinatorId}
                          >
                            <Checkbox
                              checked={selectedCoordinatorsId?.includes(
                                item?.coordinatorId
                              )}
                              sx={{
                                "& .MuiSvgIcon-root": { fontSize: 18 },
                                "&.Mui-checked": {
                                  color: "#7F56D9",
                                },
                                padding: 0.5,
                              }}
                            />
                            <Grid2
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 2,
                                fontWeight: 600,
                              }}
                            >
                              <Typography>{item?.coordinatorName}</Typography>
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: "#7F56D9",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                {item?.roleId === 1
                                  ? "(Admin)"
                                  : item?.roleId === 2
                                    ? "(Coordinator)"
                                    : null}
                              </Typography>
                            </Grid2>
                          </MenuItem>
                        ))}
                      </Select>
                      {errors?.coordinatorId?.message &&
                        selectedCoordinatorsName?.length <= 0 && (
                          <div style={{ color: "red", fontSize: "0.7rem" }}>
                            {errors?.coordinatorId?.message}
                          </div>
                        )}
                    </Grid2>
                  )}
                </Grid2>
              </Grid2>

              <Grid2
                item
                container
                rowGap={2}
                sx={{
                  display: !isSmallcreen ? "flex" : "",
                  justifyContent: "space-between",
                  flexDirection: isSmallcreen && "column",
                  marginTop: "20px",
                }}
              >
                <Grid2
                  item
                  sx={{
                    alignItems: "center",
                    width: !isSmallcreen ? "43%" : "100%",
                  }}
                >
                  {userRole === "admin" && finalSourcedBy === "BA" && (
                    <Grid2 item sx={{ alignItems: "center" }}>
                      <InputLabel className="addJobPostingInput">
                        {positionType === "Contract" ? "Contract Job Reward Type" : "Job Reward Type"}
                        {editScreen && isStatus === "Active" ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : (
                          ""
                        )}{" "}
                      </InputLabel>
                      <Controller
                        control={control}
                        name={"rewardType"}
                        render={({ field }) => (
                          <Dropdown
                            {...field}
                            className="dropdown"
                            displayEmpty
                            placeholder="Select Job Reward Type"
                            valueKey="id"
                            labelKey="label"
                            options={rewardTypes || []}
                          />
                        )}
                      />
                      {errors?.rewardType?.message && (
                        <div style={{ color: "red", fontSize: "0.7rem" }}>
                          {errors?.rewardType?.message}
                        </div>
                      )}
                    </Grid2>
                  )}
                </Grid2>

                <Grid2
                  item
                  sx={{
                    alignItems: "center",
                    width: !isSmallcreen ? "43%" : "100%",
                  }}
                >
                  <Grid2 item sx={{ alignItems: "center" }}>
                    {isCost === true &&
                      userRole === "admin" && finalSourcedBy === "BA" && (
                        <>
                          <InputLabel className="addJobPostingInput">
                            {positionType === "Contract" ? "Contract Job Rewards(Rs)" : "Job Rewards(Rs)"}
                            {editScreen && isStatus === "Active" ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : (
                              ""
                            )}
                          </InputLabel>
                          <Controller
                            control={control}
                            name="rewardsRs"
                            render={({ field }) => (
                              <TextField
                                {...field}
                                className="textfields"
                                size="small"
                                type="number"
                                sx={{
                                  flex: 1,
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    cursor: "not-allowed",
                                  },
                                }}
                                placeholder="Enter Rewards(Rs)"
                                onWheel={(e) => e.target.blur()}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                                disabled={!type}
                              />
                            )}
                          />
                          {errors?.rewardsRs?.message && (
                            <div style={{ color: "red", fontSize: "0.7rem" }}>
                              {errors?.rewardsRs?.message}
                            </div>
                          )}
                        </>
                      )}

                    {isCost === false &&
                      userRole === "admin" && finalSourcedBy === "BA" && (
                        <>
                          <InputLabel className="addJobPostingInput">
                            {positionType === "Contract" ? "Contract Job Rewards(%)" : "Job Rewards(%)"}
                            {editScreen && isStatus === "Active" ? (
                              <span style={{ color: "red" }}>*</span>
                            ) : (
                              ""
                            )}
                          </InputLabel>
                          <Controller
                            control={control}
                            name="rewardsPercent"
                            render={({ field }) => (
                              <TextField
                                {...field}
                                className="textfields"
                                size="small"
                                type="number"
                                sx={{
                                  flex: 1,
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    cursor: "not-allowed",
                                  },
                                }}
                                placeholder="Enter Rewards(%)"
                                onWheel={(e) => e.target.blur()}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                                disabled={!type}
                              />
                            )}
                          />
                          {errors?.rewardsPercent?.message && (
                            <div style={{ color: "red", fontSize: "0.7rem" }}>
                              {errors?.rewardsPercent?.message}
                            </div>
                          )}
                        </>
                      )}
                  </Grid2>
                </Grid2>

                <Grid2
                  item
                  sx={{
                    alignItems: "center",
                    width: !isSmallcreen ? "43%" : "100%",
                  }}
                >
                  {userRole === "admin" && (
                    <Grid2 item sx={{ alignItems: "center" }}>
                      <InputLabel className="addJobPostingInput">
                        {positionType === "Contract" ? "Contract Candidate Reward Type" : "Candidate Reward Type"}
                        {editScreen && isStatus === "Active" ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : (
                          ""
                        )}
                      </InputLabel>
                      <Controller
                        control={control}
                        name={"candidateRewardType"}
                        render={({ field }) => (
                          <Dropdown
                            {...field}
                            className="dropdown"
                            displayEmpty
                            placeholder="Select Candidate Reward Type"
                            valueKey="id"
                            labelKey="label"
                            options={rewardTypes || []}
                          />
                        )}
                      />
                      {errors?.candidateRewardType?.message && (
                        <div style={{ color: "red", fontSize: "0.7rem" }}>
                          {errors?.candidateRewardType?.message}
                        </div>
                      )}
                    </Grid2>
                  )}
                </Grid2>

                <Grid2
                  item
                  sx={{
                    alignItems: "center",
                    width: !isSmallcreen ? "43%" : "100%",
                  }}
                >
                  <Grid2 item sx={{ alignItems: "center" }}>
                    {isCanCost === true && userRole === "admin" && (
                      <>
                        <InputLabel className="addJobPostingInput">
                          {positionType === "Contract" ? "Contract Candidate Rewards(Rs)" : "Candidate Rewards(Rs)"}
                          {editScreen && isStatus === "Active" ? (
                            <span style={{ color: "red" }}>*</span>
                          ) : (
                            ""
                          )}
                        </InputLabel>
                        <Controller
                          control={control}
                          name="candidateRewardAmount"
                          render={({ field }) => (
                            <TextField
                              {...field}
                              className="textfields"
                              size="small"
                              type="number"
                              sx={{
                                flex: 1,
                                "& .MuiInputBase-input.Mui-disabled": {
                                  cursor: "not-allowed",
                                },
                              }}
                              placeholder="Enter Rewards(Rs)"
                              onWheel={(e) => e.target.blur()}
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                              }}
                              disabled={!candidateType}
                            />
                          )}
                        />

                        {editScreen
                          ? errors?.candidateRewardAmount?.message && (
                            <div style={{ color: "red", fontSize: "0.7rem" }}>
                              {errors?.candidateRewardAmount?.message}
                            </div>
                          )
                          : candidateType &&
                          candidateRewardAmount === "" && (
                            <div style={{ color: "red", fontSize: "0.7rem" }}>
                              Candidate reward amount is required
                            </div>
                          )}
                      </>
                    )}

                    {isCanCost === false && userRole === "admin" && (
                      <>
                        <InputLabel className="addJobPostingInput">
                          {positionType === "Contract" ? "Contract Candidate Rewards(%)" : "Candidate Rewards(%)"}
                          {editScreen && isStatus === "Active" ? (
                            <span style={{ color: "red" }}>*</span>
                          ) : (
                            ""
                          )}
                        </InputLabel>
                        <Controller
                          control={control}
                          name="candidateRewardPercentage"
                          render={({ field }) => (
                            <TextField
                              {...field}
                              className="textfields"
                              size="small"
                              type="number"
                              sx={{
                                flex: 1,
                                "& .MuiInputBase-input.Mui-disabled": {
                                  cursor: "not-allowed",
                                },
                              }}
                              placeholder="Enter Rewards(%)"
                              onWheel={(e) => e.target.blur()}
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                              }}
                              disabled={!candidateType}
                            />
                          )}
                        />

                        {editScreen || candidateType
                          ? errors?.candidateRewardPercentage?.message && (
                            <div style={{ color: "red", fontSize: "0.7rem" }}>
                              {errors?.candidateRewardPercentage?.message}
                            </div>
                          )
                          : candidateType &&
                          candidateRewardPercentage === "" && (
                            <div style={{ color: "red", fontSize: "0.7rem" }}>
                              Candidate reward percentage is required
                            </div>
                          )}
                      </>
                    )}
                  </Grid2>
                </Grid2>
              </Grid2>
            </Box>
          </Box>
          <Grid2
            item
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "20px",
              marginTop: "30px",
            }}
          >
            <MUICancelButton title="Cancel" onClick={handleCancel} />
            <MUIButton
              title={"Save Changes"}
              type="submit"
              sx={{ borderRadius: "7px", width: "130px" }}
            />
          </Grid2>
        </Box>
      </form>
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            width: "55%",
            fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
          },
        }}
      >
        {/* Header with close button */}
        <Grid2
          sx={{
            p: 3,
            borderBottom: "1px solid #cdcfd0",
            backgroundColor: "#f8f4fcff",
            position: "sticky", // ✅ make it sticky
            top: 0, // ✅ stick to top
            zIndex: 1,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid2 sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <img src={ORLogo} height={"30px"} width={"30px"} />
              <Typography
                fontWeight="bold"
                fontSize={"30px"}
                sx={{
                  fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
                }}
              >
                AI Job Description Generator
              </Typography>
            </Grid2>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Typography
            sx={{
              mt: 1,
              color: "text.secondary",
              fontSize: "18px",
              fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
            }}
          >
            Create professional job descriptions with AI assistance
          </Typography>
        </Grid2>

        <Grid2 sx={{ p: "0px 24px" }}>
          {/* Textfield */}
          <Typography
            variant="subtitle1"
            sx={{
              mt: 3,
              mb: 1,
              fontWeight: "bold",
              fontSize: "18px",
              fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
            }}
          >
            Describe the job you want to create
          </Typography>
          <TextField
            placeholder="e.g., Senior Software Engineer for fintech startup, React and Node.js experience required, remote work, competitive salary..."
            value={generateAIText}
            onChange={(e) => setGenerateAIText(e.target.value)}
            multiline
            minRows={5}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiInputBase-input": {
                fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`, // typing text
              },
              "& .MuiInputBase-input::placeholder": {
                fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`, // placeholder
              },
              backgroundColor: "#f8f4fcff",
              "&:hover": {
                borderColor: "none",
              },
            }}
          />

          {/* Generate button */}
          <Grid2 sx={{ display: "flex" }} gap={1}>
            <Button
              variant="contained"
              sx={{
                mt: 3,
                background: "linear-gradient(to right, #7f3beb, #a072f1)",
                "&:hover": { bgcolor: "#6c32d3" },
                borderRadius: 2,
                textTransform: "none",
                display: "flex",
                gap: 1,
                cursor: generating ? "not-allowed" : "pointer",
              }}
              disabled={generating || generateAIText === ""}
              onClick={dataFromAI}
            >
              {!generating ? (
                <AutoFixHighOutlinedIcon />
              ) : (
                <CircularProgress size="20px" sx={{ color: "white" }} />
              )}
              <Typography
                sx={{
                  fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
                  color: generateAIText === "" ? "none" : "white",
                }}
              >
                {generating ? "Generating...." : "Generate Description"}
              </Typography>
            </Button>
            {generateAIText !== "" && !generating && (
              <Button
                onClick={() => (setGenerateAIText(""), setBackendAi(""))}
                sx={{
                  mt: 3,
                  background: "#e9e9eaff",
                  borderRadius: 2,
                  color: "black",
                  textTransform: "none",
                  gap: 1,
                  fontWeight: "bold",
                  fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
                }}
              >
                Clear All
              </Button>
            )}
          </Grid2>
        </Grid2>
        {backendAI !== "" && (
          <Grid2 sx={{ p: 3, mt: 1 }}>
            <Grid2 sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                sx={{
                  font: "20px",
                  fontWeight: "bold",
                  fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
                }}
              >
                Generated Job Description
              </Typography>
              <Grid2
                sx={{
                  backgroundColor: "#f8f8fcff",
                  borderRadius: "10px",
                  p: 1,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#e7d8f6ff",
                    color: "#6a29dbff",
                  },
                }}
              >
                <Grid2 onClick={handleCopyAI}>
                  {copy ? (
                    <Grid2
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <img src={approve} height={"20px"} width={"20px"} />
                      <Typography
                        sx={{
                          fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
                        }}
                      >
                        Copied!
                      </Typography>
                    </Grid2>
                  ) : (
                    <Grid2
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <ContentCopyOutlinedIcon
                        sx={{ height: "15px", width: "15px" }}
                      />
                      <Typography
                        sx={{
                          fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
                        }}
                      >
                        Copy
                      </Typography>
                    </Grid2>
                  )}
                </Grid2>
              </Grid2>
            </Grid2>
            <Grid2
              sx={{
                border: "1px solid #d1d1d1",
                borderRadius: "10px",
                padding: "30px",
                mt: "15px",
              }}
            >
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                sx={{
                  color: "#767373ff",
                  letterSpacing: 0.6,
                  fontWeight: 500,
                  fontFamily: `"Segoe UI Variable", "Segoe UI", system-ui, sans-serif`,
                  whiteSpace: "pre-wrap",
                }}
              >
                {typeof backendAI === "string"
                  ? backendAI
                  : backendAI?.text ?? ""}
              </ReactMarkdown>
            </Grid2>
          </Grid2>
        )}
      </Drawer>
    </Box>
  );
};

export default AddJobPostings;
